import { isPlatformServer, DOCUMENT, CommonModule } from '@angular/common';
import { maybe } from 'typescript-monads';
import { BehaviorSubject, Subject, merge, fromEvent, interval, of } from 'rxjs';
import { shareReplay, share, mapTo, tap, startWith, distinctUntilChanged, takeUntil, switchMapTo, map, take } from 'rxjs/operators';
import { Directive, ElementRef, InjectionToken, Component, ChangeDetectionStrategy, ChangeDetectorRef, Renderer2, NgZone, Inject, PLATFORM_ID, HostListener, Input, Output, ViewChildren, ContentChild, TemplateRef, NgModule } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

const _c0 = ["floGridListItemContainer"];
function FloGridListViewComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function FloGridListViewComponent_ng_container_6_ng_container_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c1 = function (a0) { return { $implicit: a0 }; };
function FloGridListViewComponent_ng_container_6_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, FloGridListViewComponent_ng_container_6_ng_container_3_ng_container_1_Template, 1, 0, "ng-container", 14);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r5.gridListItemNoneDragTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c1, item_r2));
} }
function FloGridListViewComponent_ng_container_6_ng_container_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function FloGridListViewComponent_ng_container_6_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, FloGridListViewComponent_ng_container_6_ng_container_4_ng_container_1_Template, 1, 0, "ng-container", 14);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r6.gridListItemSomeDragTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c1, item_r2));
} }
function FloGridListViewComponent_ng_container_6_div_8_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function FloGridListViewComponent_ng_container_6_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵtemplate(1, FloGridListViewComponent_ng_container_6_div_8_ng_container_1_Template, 1, 0, "ng-container", 14);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("fill-to-fit", ctx_r8.fillToFit);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r8.gridListItemSomeTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(4, _c1, item_r2));
} }
function FloGridListViewComponent_ng_container_6_div_9_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function FloGridListViewComponent_ng_container_6_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵtemplate(1, FloGridListViewComponent_ng_container_6_div_9_ng_container_1_Template, 1, 0, "ng-container", 14);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r9 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("fill-to-fit", ctx_r9.fillToFit);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r9.gridListItemNoneTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(4, _c1, item_r2));
} }
function FloGridListViewComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 5, 6);
    ɵngcc0.ɵɵtemplate(3, FloGridListViewComponent_ng_container_6_ng_container_3_Template, 2, 4, "ng-container", 7);
    ɵngcc0.ɵɵtemplate(4, FloGridListViewComponent_ng_container_6_ng_container_4_Template, 2, 4, "ng-container", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 8, 9);
    ɵngcc0.ɵɵlistener("click", function FloGridListViewComponent_ng_container_6_Template_div_click_5_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r19); const idx_r3 = restoredCtx.index; const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r18.setSelectedIndex(idx_r3)); })("floGridListDragDropDragoverChange", function FloGridListViewComponent_ng_container_6_Template_div_floGridListDragDropDragoverChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r20 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r20.dragSource.next($event)); });
    ɵngcc0.ɵɵelementContainerStart(7, 10);
    ɵngcc0.ɵɵtemplate(8, FloGridListViewComponent_ng_container_6_div_8_Template, 2, 6, "div", 11);
    ɵngcc0.ɵɵtemplate(9, FloGridListViewComponent_ng_container_6_div_9_Template, 2, 6, "div", 12);
    ɵngcc0.ɵɵelementContainerEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 13);
    ɵngcc0.ɵɵpipe(11, "async");
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r2 = ctx.$implicit;
    const idx_r3 = ctx.index;
    const _r4 = ɵngcc0.ɵɵreference(2);
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitch", item_r2.hasValue);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngSwitchCase", false);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", true);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵstyleProp("flex-basis", item_r2.flexBasis, "%")("padding-top", item_r2.padTop, "%");
    ɵngcc0.ɵɵproperty("floGridListDragDrop", ctx_r1.dragDropEnabled)("floGridListDragDropItem", item_r2.value)("floGridListDragDropIndex", idx_r3)("floGridListDragDropGridRef", ctx_r1)("floGridListDragDropDragRef", ctx_r1.gridListItemSomeDragTemplate || ctx_r1.gridListItemNoneDragTemplate ? _r4 : undefined)("floGridListDragDropHoverBgEnabled", ctx_r1.dragDropHoverBgEnabled)("floGridListDragDropHoverBgColor", ctx_r1.dragDropHoverBgColor)("floGridListDragDropHoverBgOpacity", ctx_r1.dragDropHoverBgOpacity);
    ɵngcc0.ɵɵattribute("id", item_r2 == null ? null : item_r2.containerId);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngSwitch", item_r2.hasValue);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", true);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", false);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("selection-border", item_r2.isShowingBorder)("list-overlay-hide", ɵngcc0.ɵɵpipeBind1(11, 23, ctx_r1.hideOverlay));
} }
function FloGridListComponent_ng_container_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function FloGridListComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵtemplate(2, FloGridListComponent_ng_container_0_ng_container_2_Template, 1, 0, "ng-container", 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const viewItem_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("floGridListDragDropItem", viewItem_r1.item)("ngClass", ctx_r0.itemsNgClass)("ngStyle", ctx_r0.itemsNgStyle);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r0.itemTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(5, _c1, viewItem_r1));
} }
const swapItemsViaIndices = (/**
 * @template T
 * @param {?} collection
 * @param {?} idx1
 * @param {?} idx2
 * @return {?}
 */
(collection, idx1, idx2) => {
    if (!collection.length) {
        return [];
    }
    // tslint:disable-next-line: readonly-array
    /** @type {?} */
    const _cloned = [...collection]
    // tslint:disable-next-line: no-object-mutation
    ;
    // tslint:disable-next-line: no-object-mutation
    _cloned[idx1] = collection[idx2];
    // tslint:disable-next-line: no-object-mutation
    _cloned[idx2] = collection[idx1];
    return _cloned;
});

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template TElement
 */
class FloGridListOverlayDirective {
    /**
     * @param {?} elmRef
     */
    constructor(elmRef) {
        this.elmRef = elmRef;
    }
}
FloGridListOverlayDirective.ɵfac = function FloGridListOverlayDirective_Factory(t) { return new (t || FloGridListOverlayDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
FloGridListOverlayDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: FloGridListOverlayDirective, selectors: [["", "floGridListOverlay", ""]] });
/** @nocollapse */
FloGridListOverlayDirective.ctorParameters = () => [
    { type: ElementRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FloGridListOverlayDirective, [{
        type: Directive,
        args: [{
                selector: '[floGridListOverlay]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, null); })();
/**
 * @template TElement
 */
class FloGridListItemSomeDirective {
    /**
     * @param {?} elmRef
     */
    constructor(elmRef) {
        this.elmRef = elmRef;
    }
}
FloGridListItemSomeDirective.ɵfac = function FloGridListItemSomeDirective_Factory(t) { return new (t || FloGridListItemSomeDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
FloGridListItemSomeDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: FloGridListItemSomeDirective, selectors: [["", "floGridListItemSome", ""]] });
/** @nocollapse */
FloGridListItemSomeDirective.ctorParameters = () => [
    { type: ElementRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FloGridListItemSomeDirective, [{
        type: Directive,
        args: [{
                selector: '[floGridListItemSome]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, null); })();
/**
 * @template TElement
 */
class FloGridListItemNoneDirective {
    /**
     * @param {?} elmRef
     */
    constructor(elmRef) {
        this.elmRef = elmRef;
    }
}
FloGridListItemNoneDirective.ɵfac = function FloGridListItemNoneDirective_Factory(t) { return new (t || FloGridListItemNoneDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
FloGridListItemNoneDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: FloGridListItemNoneDirective, selectors: [["", "floGridListItemNone", ""]] });
/** @nocollapse */
FloGridListItemNoneDirective.ctorParameters = () => [
    { type: ElementRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FloGridListItemNoneDirective, [{
        type: Directive,
        args: [{
                selector: '[floGridListItemNone]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, null); })();
/**
 * @template TElement
 */
class FloGridListItemSomeDragDirective {
    /**
     * @param {?} elmRef
     */
    constructor(elmRef) {
        this.elmRef = elmRef;
    }
}
FloGridListItemSomeDragDirective.ɵfac = function FloGridListItemSomeDragDirective_Factory(t) { return new (t || FloGridListItemSomeDragDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
FloGridListItemSomeDragDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: FloGridListItemSomeDragDirective, selectors: [["", "floGridListItemSomeDrag", ""]] });
/** @nocollapse */
FloGridListItemSomeDragDirective.ctorParameters = () => [
    { type: ElementRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FloGridListItemSomeDragDirective, [{
        type: Directive,
        args: [{
                selector: '[floGridListItemSomeDrag]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, null); })();
/**
 * @template TElement
 */
class FloGridListItemNoneDragDirective {
    /**
     * @param {?} elmRef
     */
    constructor(elmRef) {
        this.elmRef = elmRef;
    }
}
FloGridListItemNoneDragDirective.ɵfac = function FloGridListItemNoneDragDirective_Factory(t) { return new (t || FloGridListItemNoneDragDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
FloGridListItemNoneDragDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: FloGridListItemNoneDragDirective, selectors: [["", "floGridListItemNoneDrag", ""]] });
/** @nocollapse */
FloGridListItemNoneDragDirective.ctorParameters = () => [
    { type: ElementRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FloGridListItemNoneDragDirective, [{
        type: Directive,
        args: [{
                selector: '[floGridListItemNoneDrag]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const FLO_GRID_LIST_ITEMS = new InjectionToken('fs.grid.list.items');
/** @type {?} */
const FLO_GRID_LIST_COUNT = new InjectionToken('fs.grid.list.count');
/** @type {?} */
const FLO_GRID_LIST_MIN_COUNT = new InjectionToken('fs.grid.list.count.min');
/** @type {?} */
const FLO_GRID_LIST_MAX_COUNT = new InjectionToken('fs.grid.list.count.max');
/** @type {?} */
const FLO_GRID_LIST_MAX_HEIGHT = new InjectionToken('fs.grid.list.maxheight');
/** @type {?} */
const FLO_GRID_LIST_SELECTED_INDEX = new InjectionToken('fs.grid.list.selectedIndex');
/** @type {?} */
const FLO_GRID_LIST_SELECT_NEXT_EMPTY_ON_COUNT = new InjectionToken('fs.grid.list.select.next.count');
/** @type {?} */
const FLO_GRID_LIST_SELECT_NEXT_EMPTY_ON_ADD = new InjectionToken('fs.grid.list.select.next.add');
/** @type {?} */
const FLO_GRID_LIST_SELECT_FROM_LOWER_INDICES_FIRST = new InjectionToken('fs.grid.list.select.lwr.idx');
/** @type {?} */
const FLO_GRID_LIST_CONTAINER_ID_PREFIX = new InjectionToken('fs.grid.list.id.prefix');
/** @type {?} */
const FLO_GRID_LIST_FILL_TO_FIT = new InjectionToken('fs.grid.list.fill.fit');
/** @type {?} */
const FLO_GRID_LIST_GUID_GEN = new InjectionToken('fs.grid.list.guid')
// PRIMARY OVERLAY
;
// PRIMARY OVERLAY
/** @type {?} */
const FLO_GRID_LIST_OVERLAY_ENABLED = new InjectionToken('fs.grid.list.overlay.enabled');
/** @type {?} */
const FLO_GRID_LIST_OVERLAY_START = new InjectionToken('fs.grid.list.overlay.start');
/** @type {?} */
const FLO_GRID_LIST_OVERLAY_FADEOUT = new InjectionToken('fs.grid.list.overlay.fadeout');
/** @type {?} */
const FLO_GRID_LIST_OVERLAY_THROTTLE = new InjectionToken('fs.grid.list.overlay.throttle');
/** @type {?} */
const FLO_GRID_LIST_OVERLAY_STATIC = new InjectionToken('fs.grid.list.overlay.static');
/** @type {?} */
const FLO_GRID_LIST_OVERLAY_NG_CLASS = new InjectionToken('fs.grid.list.overlay.ngclass');
/** @type {?} */
const FLO_GRID_LIST_OVERLAY_NG_STYLE = new InjectionToken('fs.grid.list.overlay.ngstyle')
// DRAG DROP
;
// DRAG DROP
/** @type {?} */
const FLO_GRID_LIST_DRAG_DROP_ENABLED = new InjectionToken('fs.grid.list.dragdrop.enabled');
/** @type {?} */
const FLO_GRID_LIST_DRAG_DROP_FROM_LISTS_ENABLED = new InjectionToken('fs.grid.list.dragdroplists.enabled');
/** @type {?} */
const FLO_GRID_LIST_DRAG_DROP_HOVER_BG_ENABLED = new InjectionToken('fs.grid.list.hover.enabled');
/** @type {?} */
const FLO_GRID_LIST_DRAG_DROP_HOVER_BG_COLOR = new InjectionToken('fs.grid.list.hover.bgcolor');
/** @type {?} */
const FLO_GRID_LIST_DRAG_DROP_HOVER_BG_OPACITY = new InjectionToken('fs.grid.list.hover.bgopacity');
/** @type {?} */
const FLO_GRID_LIST_DRAG_DROP_SUPPORTED_FN = new InjectionToken('fs.grid.list.dragdrop.supported');
/** @type {?} */
const FLO_GRID_LIST_AUTO_FILL_FROM_LIST_ON_LOAD = new InjectionToken('fs.grid.list.lst.autofill');
/** @type {?} */
const FLO_GRID_LIST_ASPECT_RATIO = new InjectionToken('fs.grid.list.lst.aspect');
/** @type {?} */
const FLO_GRID_LIST_TRACK_BY_FN = new InjectionToken('fs.grid.list.trackby');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template TItem
 */
class FloGridListViewComponent {
    /**
     * @param {?} elmRef
     * @param {?} cdRef
     * @param {?} rd
     * @param {?} zone
     * @param {?} _platformId
     * @param {?} _items
     * @param {?} _count
     * @param {?} _min
     * @param {?} _max
     * @param {?} _maxHeight
     * @param {?} _selectedIndex
     * @param {?} _selectNextEmptyOnCount
     * @param {?} _selectNextEmptyOnAdd
     * @param {?} _selectFromLowerIndicesFirst
     * @param {?} _overlayEnabled
     * @param {?} _overlayStart
     * @param {?} _overlayFadeout
     * @param {?} _overlayThrottle
     * @param {?} _overlayStatic
     * @param {?} _overlayNgClass
     * @param {?} _overlayNgStyle
     * @param {?} _dragDropEnabled
     * @param {?} _aspectRatio
     * @param {?} _trackByFn
     * @param {?} _containerIdPrefix
     * @param {?} _fillToFit
     * @param {?} _dragDropHoverBgEnabled
     * @param {?} _dragDropHoverBgColor
     * @param {?} _dragDropHoverBgOpacity
     */
    constructor(elmRef, cdRef, rd, zone, _platformId, _items, _count, _min, _max, _maxHeight, _selectedIndex, _selectNextEmptyOnCount, _selectNextEmptyOnAdd, _selectFromLowerIndicesFirst, _overlayEnabled, _overlayStart, _overlayFadeout, _overlayThrottle, _overlayStatic, _overlayNgClass, _overlayNgStyle, _dragDropEnabled, _aspectRatio, _trackByFn, _containerIdPrefix, _fillToFit, _dragDropHoverBgEnabled, _dragDropHoverBgColor, _dragDropHoverBgOpacity) {
        this.elmRef = elmRef;
        this.cdRef = cdRef;
        this.rd = rd;
        this.zone = zone;
        this._platformId = _platformId;
        this._items = _items;
        this._count = _count;
        this._min = _min;
        this._max = _max;
        this._maxHeight = _maxHeight;
        this._selectedIndex = _selectedIndex;
        this._selectNextEmptyOnCount = _selectNextEmptyOnCount;
        this._selectNextEmptyOnAdd = _selectNextEmptyOnAdd;
        this._selectFromLowerIndicesFirst = _selectFromLowerIndicesFirst;
        this._overlayEnabled = _overlayEnabled;
        this._overlayStart = _overlayStart;
        this._overlayFadeout = _overlayFadeout;
        this._overlayThrottle = _overlayThrottle;
        this._overlayStatic = _overlayStatic;
        this._overlayNgClass = _overlayNgClass;
        this._overlayNgStyle = _overlayNgStyle;
        this._dragDropEnabled = _dragDropEnabled;
        this._aspectRatio = _aspectRatio;
        this._trackByFn = _trackByFn;
        this._containerIdPrefix = _containerIdPrefix;
        this._fillToFit = _fillToFit;
        this._dragDropHoverBgEnabled = _dragDropHoverBgEnabled;
        this._dragDropHoverBgColor = _dragDropHoverBgColor;
        this._dragDropHoverBgOpacity = _dragDropHoverBgOpacity;
        this.setSelectedIndex = (/**
         * @param {?} index
         * @return {?}
         */
        (index) => {
            this.selectedIndex = index;
            this.setSelectedIdViaIndex(index);
        });
        this.isFullscreen = (/**
         * @return {?}
         */
        () => isPlatformServer(this._platformId) ? false : 1 >= window.outerHeight - window.innerHeight);
        this.viewItemSource = new BehaviorSubject([]);
        this.itemsChange = new Subject();
        this.countChange = new Subject();
        this.minChange = new Subject();
        this.maxChange = new Subject();
        this.maxheightChange = new Subject();
        this.selectedIdChange = new Subject();
        this.selectedIndexChange = new Subject();
        this.selectedElementChange = new Subject();
        this.overlayEnabledChange = new Subject();
        this.overlayStaticChange = new Subject();
        this.overlayStartChange = new Subject();
        this.overlayFadeoutChange = new Subject();
        this.overlayThrottleChange = new Subject();
        this.overlayNgClassChange = new Subject();
        this.overlayNgStyleChange = new Subject();
        this.dragDropEnabledChange = new Subject();
        this.dragDropHoverBgEnabledChange = new Subject();
        this.dragDropHoverBgColorChange = new Subject();
        this.dragDropHoverBgOpacityChange = new Subject();
        this.selectNextEmptyOnCountChange = new Subject();
        this.selectNextEmptyOnAddChange = new Subject();
        this.selectFromLowerIndicesFirstChange = new Subject();
        this.aspectRatioChange = new Subject();
        this.trackByFnChange = new Subject();
        this.containerIdPrefixChange = new Subject();
        this.fillToFitChange = new Subject();
        this.cdRefChange = merge(this.selectedIdChange, this.selectedIndexChange, this.itemsChange, this.countChange);
        this.viewItemChange = this.viewItemSource.asObservable().pipe(shareReplay(1));
        this.dragSource = new Subject();
        this.onDestroySource = new Subject();
        this.onDestroy = this.onDestroySource.pipe(share());
        this.cursorInsideElement = this.zone.runOutsideAngular((/**
         * @return {?}
         */
        () => merge(this.dragSource.pipe(mapTo(true), tap((/**
         * @return {?}
         */
        () => this.cycleOverlay()))), fromEvent(this.elmRef.nativeElement, 'mousemove').pipe(mapTo(true), tap((/**
         * @return {?}
         */
        () => this.cycleOverlay()))), fromEvent(this.elmRef.nativeElement, 'mouseenter').pipe(mapTo(true)), fromEvent(this.elmRef.nativeElement, 'mouseleave').pipe(mapTo(false))).pipe(startWith(this.overlayStart), distinctUntilChanged())));
        this.fadeoutIntervalReset = new Subject();
        this.stableFadeoutInterval = this.zone.runOutsideAngular((/**
         * @return {?}
         */
        () => interval(this.overlayFadeout).pipe(mapTo(false), startWith(this.overlayStart), takeUntil(this.onDestroy))));
        this.fadeoutIntervalWithReset = this.fadeoutIntervalReset.pipe(startWith(false), switchMapTo(this.stableFadeoutInterval));
        this.fadeStream = (isPlatformServer(this._platformId)
            ? of(this.overlayEnabled)
            : merge(this.cursorInsideElement, this.fadeoutIntervalWithReset)).pipe(distinctUntilChanged(), shareReplay(1));
        this.showOverlay = this.fadeStream.pipe(map((/**
         * @param {?} b
         * @return {?}
         */
        b => this.overlayEnabled && b)));
        this.hideOverlay = this.showOverlay.pipe(map((/**
         * @param {?} show
         * @return {?}
         */
        show => !show)), shareReplay(1));
        this.toggleCursor = (/**
         * @param {?} show
         * @return {?}
         */
        (show) => this.rd.setStyle(this.elmRef.nativeElement, 'cursor', show ? 'default' : 'none'));
        this.trySelectNextEmpty = (/**
         * @return {?}
         */
        () => this.findNextEmptyIndex().tapSome(this.setSelectedIndex));
        this.setSelectedIdViaIndex = (/**
         * @param {?} idx
         * @return {?}
         */
        (idx) => {
            this.setSelectedId(maybe(this.items[idx]).map((/**
             * @param {?} a
             * @return {?}
             */
            a => a.id)).valueOrUndefined());
            this.cycleOverlay();
        });
        this.cycleOverlay = (/**
         * @return {?}
         */
        () => {
            this.fadeoutIntervalReset.next(true);
            this.cdRef.markForCheck();
        });
        this.constructContainerId = (/**
         * @param {?} token
         * @return {?}
         */
        (token) => `${this.containerIdPrefix}${token}`);
        this.createViewItems = (/**
         * @return {?}
         */
        () => {
            /** @type {?} */
            const square = Math.ceil(Math.sqrt(this.count));
            /** @type {?} */
            const stub = new Array(this.count)
                .fill(maybe())
                .map((/**
             * @param {?} val
             * @param {?} idx
             * @return {?}
             */
            (val, idx) => this.items[idx] ? maybe(this.items[idx]) : val));
            return stub.map((/**
             * @param {?} value
             * @param {?} idx
             * @return {?}
             */
            (value, idx) => {
                /** @type {?} */
                const isSelected = this.selectedIndex === idx;
                return {
                    hasValue: value.isSome(),
                    value: value.valueOrUndefined(),
                    flexBasis: 100 / square,
                    padTop: this.aspectRatioPct / square,
                    isShowingBorder: isSelected && this.count > 1,
                    isSelected,
                    isNotSelected: !isSelected,
                    containerId: value.map((/**
                     * @param {?} i
                     * @return {?}
                     */
                    i => i.id))
                        .map(this.constructContainerId)
                        .valueOr(this.constructContainerId(idx))
                };
            }));
        });
        this.update = (/**
         * @return {?}
         */
        () => {
            this.viewItemSource.next(this.createViewItems());
            this.cdRef.detectChanges();
        });
        this.setItemAtIndex = (/**
         * @param {?} idx
         * @param {?} val
         * @return {?}
         */
        (idx, val) => {
            // tslint:disable-next-line: readonly-array
            /** @type {?} */
            const _cloned = [...this.items];
            _cloned[idx] = val;
            this.setItems(_cloned);
        });
        this.swapItemsAtIndex = (/**
         * @param {?} toIndex
         * @param {?} toVal
         * @param {?=} fromIndex
         * @return {?}
         */
        (toIndex, toVal, fromIndex) => typeof fromIndex === 'number'
            ? this.setItems(swapItemsViaIndices(this.items, toIndex, fromIndex))
            : this.setItemAtIndex(toIndex, toVal));
        this.setValueOfSelected = (/**
         * @param {?} val
         * @return {?}
         */
        (val) => this.setItemAtIndex(this.selectedIndex, val));
        this.getItemIndexById = (/**
         * @param {?} id
         * @return {?}
         */
        (id) => this.items.findIndex((/**
         * @param {?} a
         * @return {?}
         */
        a => a !== undefined && a.id === id)));
        this.getItemIndex = (/**
         * @param {?} item
         * @return {?}
         */
        (item) => this.getItemIndexById(item.id));
        this.isCount = (/**
         * @param {?} count
         * @return {?}
         */
        (count) => this.count === count);
        this.isIdSelected = (/**
         * @param {?} id
         * @return {?}
         */
        (id) => this.selectedId === id);
        this.isIdNotSelected = (/**
         * @param {?} id
         * @return {?}
         */
        (id) => !this.isIdSelected(id));
        this.isItemSelected = (/**
         * @param {?} item
         * @return {?}
         */
        (item) => this.selectedId === item.id);
        this.isItemNotSelected = (/**
         * @param {?} item
         * @return {?}
         */
        (item) => !this.isItemSelected(item));
        this.isItemInView = (/**
         * @param {?} item
         * @return {?}
         */
        (item) => {
            /** @type {?} */
            const itemIndex = this.getItemIndex(item);
            return itemIndex >= 0 && itemIndex <= this.count;
        });
        this.isItemInGrid = (/**
         * @param {?} item
         * @return {?}
         */
        (item) => this.getItemIndex(item) >= 0);
        this.isItemNotInGrid = (/**
         * @param {?} item
         * @return {?}
         */
        (item) => !this.isItemInGrid(item));
        this.isItemInAnotherIndex = (/**
         * @param {?} item
         * @param {?} idx
         * @return {?}
         */
        (item, idx) => maybe(this.getItemIndex(item))
            .filter((/**
         * @param {?} i
         * @return {?}
         */
        i => i >= 0))
            .filter((/**
         * @param {?} i
         * @return {?}
         */
        i => i !== idx))
            .map((/**
         * @return {?}
         */
        () => true))
            .valueOr(false));
        this.isItemInNotAnotherIndex = (/**
         * @param {?} item
         * @param {?} idx
         * @return {?}
         */
        (item, idx) => !this.isItemInAnotherIndex(item, idx));
        this.canRemoveItem = (/**
         * @param {?} item
         * @return {?}
         */
        (item) => this.isItemInGrid(item));
        this.canRemoveItemSelected = (/**
         * @param {?} item
         * @return {?}
         */
        (item) => this.isItemSelected(item));
        this.canSwapItem = (/**
         * @param {?} item
         * @param {?=} toIndex
         * @return {?}
         */
        (item, toIndex = this.selectedIndex) => this.isItemInAnotherIndex(item, toIndex));
        this.isIndexEmpty = (/**
         * @param {?} idx
         * @return {?}
         */
        (idx) => this.items[idx] === undefined);
        this.canSelectItem = (/**
         * @param {?} item
         * @return {?}
         */
        (item) => this.isItemInView(item) && this.isItemNotSelected(item));
        this.canAddItem = (/**
         * @param {?} item
         * @param {?=} toIndex
         * @return {?}
         */
        (item, toIndex = this.selectedIndex) => this.isIndexEmpty(toIndex) && this.isItemInNotAnotherIndex(item, toIndex));
        this.canReplaceItem = (/**
         * @param {?} item
         * @param {?=} toIndex
         * @return {?}
         */
        (item, toIndex = this.selectedIndex) => this.isItemNotSelected(item) && !this.canAddItem(item, toIndex));
        this.setItem = (/**
         * @param {?} item
         * @param {?=} idx
         * @return {?}
         */
        (item, idx = this.selectedIndex) => {
            this.setItemAtIndex(idx, item);
            if (this.selectNextEmptyOnAdd) {
                this.trySelectNextEmpty();
            }
        });
        this.removeItem = (/**
         * @param {?} item
         * @return {?}
         */
        (item) => maybe(this.getItemIndexById(item.id))
            .filter((/**
         * @param {?} idx
         * @return {?}
         */
        idx => idx >= 0))
            .tapSome((/**
         * @param {?} idx
         * @return {?}
         */
        idx => this.setItems([...this.items.slice(0, idx), undefined, ...this.items.slice(idx + 1)]))));
        this.replaceItem = (/**
         * @param {?} item
         * @param {?=} idx
         * @return {?}
         */
        (item, idx = this.selectedIndex) => {
            /** @type {?} */
            const previousIndex = this.getItemIndex(item)
            // tslint:disable-next-line: readonly-array
            ;
            // tslint:disable-next-line: readonly-array
            /** @type {?} */
            const _cloned = [...this.items];
            _cloned[idx] = item;
            _cloned[previousIndex] = undefined;
            this.setItems(_cloned);
        });
        this.swapItems = (/**
         * @param {?} item
         * @param {?=} idx
         * @return {?}
         */
        (item, idx = this.selectedIndex) => this.setItems(swapItemsViaIndices(this.items, idx, this.getItemIndex(item))));
        this.resetItems = (/**
         * @return {?}
         */
        () => {
            this.items = [];
            this.setSelectedId(undefined);
        });
        // TODO: TEST THIS SCENARIO!
        this.findNextEmptyIndex = (/**
         * @return {?}
         */
        () => {
            /** @type {?} */
            const findByBaseIndex = (/**
             * @param {?=} startIndex
             * @return {?}
             */
            (startIndex = 0) => maybe(this.viewItemSource.getValue()
                .slice(startIndex, this.count)
                .findIndex((/**
             * @param {?} b
             * @return {?}
             */
            b => !b.hasValue)))
                .filter((/**
             * @param {?} idx
             * @return {?}
             */
            idx => idx >= 0))
                .map((/**
             * @param {?} a
             * @return {?}
             */
            a => a + startIndex)));
            return this.selectFromLowerIndicesFirst
                ? findByBaseIndex()
                : findByBaseIndex(this.selectedIndex).match({ some: maybe, none: findByBaseIndex });
        });
        this.fillNextEmpty = (/**
         * @param {?} item
         * @return {?}
         */
        (item) => this.findNextEmptyIndex()
            .tapSome((/**
         * @param {?} idx
         * @return {?}
         */
        idx => this.setItem(item, idx))));
    }
    /**
     * @return {?}
     */
    fullscreenchange() {
        this.update();
    }
    /**
     * @return {?}
     */
    get items() {
        return (/** @type {?} */ (this._items));
    }
    /**
     * @param {?} items
     * @return {?}
     */
    set items(items) {
        this._items = items;
        this.itemsChange.next(items);
    }
    /**
     * @param {?} items
     * @return {?}
     */
    setItems(items) {
        this.items = items;
        this.setSelectedIdViaIndex(this.selectedIndex);
    }
    /**
     * @return {?}
     */
    get count() {
        return this._count;
    }
    /**
     * @param {?} val
     * @return {?}
     */
    set count(val) {
        if (val >= this._min && val <= this._max) {
            this._count = val;
            this.countChange.next(this._count);
        }
        if (this.selectedIndex >= val) { // Ensure seletedIndex doesn't go out of bounds visually
            this.setSelectedIndex(0);
        }
        else if (this.selectNextEmptyOnCount) {
            this.trySelectNextEmpty();
        }
    }
    /**
     * @param {?} count
     * @return {?}
     */
    setCount(count) {
        this.count = count;
    }
    /**
     * @return {?}
     */
    get min() {
        return this._min;
    }
    /**
     * @param {?} val
     * @return {?}
     */
    set min(val) {
        this._min = val;
        this.minChange.next(this._min);
        if (this.count < val) {
            this.setCount(val);
        }
    }
    /**
     * @param {?} min
     * @return {?}
     */
    setMin(min) {
        this.min = min;
    }
    /**
     * @return {?}
     */
    get max() {
        return this._max;
    }
    /**
     * @param {?} val
     * @return {?}
     */
    set max(val) {
        this._max = val;
        this.maxChange.next(this._max);
        if (this.count > val) {
            this.setCount(val);
        }
    }
    /**
     * @param {?} min
     * @return {?}
     */
    setMax(min) {
        this.max = min;
    }
    /**
     * @return {?}
     */
    get selectNextEmptyOnCount() {
        return this._selectNextEmptyOnCount;
    }
    /**
     * @param {?} val
     * @return {?}
     */
    set selectNextEmptyOnCount(val) {
        this._selectNextEmptyOnCount = val;
        this.selectNextEmptyOnCountChange.next(val);
    }
    /**
     * @param {?} val
     * @return {?}
     */
    setSelectNextEmptyOnCount(val) {
        this.selectNextEmptyOnCount = val;
    }
    /**
     * @return {?}
     */
    get selectNextEmptyOnAdd() {
        return this._selectNextEmptyOnAdd;
    }
    /**
     * @param {?} val
     * @return {?}
     */
    set selectNextEmptyOnAdd(val) {
        this._selectNextEmptyOnAdd = val;
        this.selectNextEmptyOnAddChange.next(val);
    }
    /**
     * @param {?} val
     * @return {?}
     */
    setSelectNextEmptyOnAdd(val) {
        this.selectNextEmptyOnAdd = val;
    }
    /**
     * @return {?}
     */
    get selectFromLowerIndicesFirst() {
        return this._selectFromLowerIndicesFirst;
    }
    /**
     * @param {?} val
     * @return {?}
     */
    set selectFromLowerIndicesFirst(val) {
        this._selectFromLowerIndicesFirst = val;
        this.selectFromLowerIndicesFirstChange.next(val);
    }
    /**
     * @param {?} val
     * @return {?}
     */
    setSelectFromLowerIndicesFirst(val) {
        this.selectFromLowerIndicesFirst = val;
    }
    /**
     * @return {?}
     */
    get maxheight() {
        return this._maxHeight;
    }
    /**
     * @param {?} val
     * @return {?}
     */
    set maxheight(val) {
        this._maxHeight = val;
        this.maxheightChange.next(val);
    }
    /**
     * @param {?} val
     * @return {?}
     */
    setMaxheight(val) {
        this.maxheight = val;
    }
    /**
     * @return {?}
     */
    get selectedIndex() {
        return this._selectedIndex;
    }
    /**
     * @param {?} index
     * @return {?}
     */
    set selectedIndex(index) {
        if (index >= 0 && index < this.count) {
            this._selectedIndex = index;
            this.selectedIndexChange.next(index);
        }
    }
    /**
     * @return {?}
     */
    get selectedId() {
        return this._selectedId;
    }
    /**
     * @param {?} id
     * @return {?}
     */
    set selectedId(id) {
        this._selectedId = id;
        this.selectedIdChange.next(id);
    }
    /**
     * @param {?=} id
     * @return {?}
     */
    setSelectedId(id) {
        this.selectedId = id;
    }
    /**
     * @return {?}
     */
    get overlayEnabled() {
        return this._overlayEnabled;
    }
    /**
     * @param {?} enabled
     * @return {?}
     */
    set overlayEnabled(enabled) {
        this._overlayEnabled = enabled;
        this.overlayEnabledChange.next(enabled);
    }
    /**
     * @param {?} enabled
     * @return {?}
     */
    setOverlayEnabled(enabled) {
        this.overlayEnabled = enabled;
    }
    /**
     * @return {?}
     */
    get overlayStatic() {
        return this._overlayStatic;
    }
    /**
     * @param {?} isStatic
     * @return {?}
     */
    set overlayStatic(isStatic) {
        this._overlayStatic = isStatic;
        this.overlayStaticChange.next(isStatic);
    }
    /**
     * @param {?} isStatic
     * @return {?}
     */
    setOverlayStatic(isStatic) {
        this.overlayStatic = isStatic;
    }
    /**
     * @return {?}
     */
    get overlayStart() {
        return this._overlayStart;
    }
    /**
     * @param {?} start
     * @return {?}
     */
    set overlayStart(start) {
        this._overlayStart = start;
        this.overlayStartChange.next(start);
    }
    /**
     * @param {?} start
     * @return {?}
     */
    setOverlayStart(start) {
        this.overlayStart = start;
    }
    /**
     * @return {?}
     */
    get overlayFadeout() {
        return this._overlayFadeout;
    }
    /**
     * @param {?} fadeout
     * @return {?}
     */
    set overlayFadeout(fadeout) {
        this._overlayFadeout = fadeout;
        this.overlayFadeoutChange.next(fadeout);
    }
    /**
     * @param {?} fadeout
     * @return {?}
     */
    setOverlayFadeout(fadeout) {
        this.overlayFadeout = fadeout;
    }
    /**
     * @return {?}
     */
    get overlayThrottle() {
        return this._overlayThrottle;
    }
    /**
     * @param {?} throttle
     * @return {?}
     */
    set overlayThrottle(throttle) {
        this._overlayThrottle = throttle;
        this.overlayThrottleChange.next(throttle);
    }
    /**
     * @param {?} throttle
     * @return {?}
     */
    setOverlayThrottle(throttle) {
        this.overlayThrottle = throttle;
    }
    /**
     * @return {?}
     */
    get overlayNgClass() {
        return this._overlayNgClass;
    }
    /**
     * @param {?} ngClass
     * @return {?}
     */
    set overlayNgClass(ngClass) {
        this._overlayNgClass = ngClass;
        this.overlayNgClassChange.next(ngClass);
    }
    /**
     * @param {?} ngClass
     * @return {?}
     */
    setOverlayNgClass(ngClass) {
        this.overlayNgClass = ngClass;
    }
    /**
     * @return {?}
     */
    get overlayNgStyle() {
        return this._overlayNgStyle;
    }
    /**
     * @param {?} ngStyle
     * @return {?}
     */
    set overlayNgStyle(ngStyle) {
        this._overlayNgStyle = ngStyle;
        this.overlayNgStyleChange.next(ngStyle);
    }
    /**
     * @param {?} ngStyle
     * @return {?}
     */
    setOverlayNgStyle(ngStyle) {
        this.overlayNgStyle = ngStyle;
    }
    /**
     * @return {?}
     */
    get dragDropEnabled() {
        return this._dragDropEnabled;
    }
    /**
     * @param {?} enabled
     * @return {?}
     */
    set dragDropEnabled(enabled) {
        this._dragDropEnabled = enabled;
        this.dragDropEnabledChange.next(enabled);
    }
    /**
     * @param {?} enabled
     * @return {?}
     */
    setDragDropEnabled(enabled) {
        this.dragDropEnabled = enabled;
    }
    /**
     * @return {?}
     */
    get aspectRatio() {
        return this._aspectRatio;
    }
    /**
     * @param {?} ratio
     * @return {?}
     */
    set aspectRatio(ratio) {
        /** @type {?} */
        const _ratio = typeof ratio === 'number' ? ratio : this._aspectRatio;
        this._aspectRatio = _ratio;
        this.aspectRatioChange.next(_ratio);
    }
    /**
     * @param {?} percent
     * @return {?}
     */
    setAspectRatio(percent) {
        this.aspectRatio = percent;
    }
    /**
     * @return {?}
     */
    get trackByFn() {
        return this._trackByFn;
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    set trackByFn(fn) {
        /** @type {?} */
        const _fn = typeof fn === 'function' ? fn : this._trackByFn;
        this._trackByFn = _fn;
        this.trackByFnChange.next(_fn);
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    setTrackByFn(fn) {
        this.trackByFn = fn;
    }
    /**
     * @return {?}
     */
    get containerIdPrefix() {
        return this._containerIdPrefix;
    }
    /**
     * @param {?} prefix
     * @return {?}
     */
    set containerIdPrefix(prefix) {
        this._containerIdPrefix = prefix;
        this.containerIdPrefixChange.next(prefix);
    }
    /**
     * @param {?} prefix
     * @return {?}
     */
    setContainerIdPrefix(prefix) {
        this.containerIdPrefix = prefix;
    }
    /**
     * @return {?}
     */
    get fillToFit() {
        return this._fillToFit;
    }
    /**
     * @param {?} enable
     * @return {?}
     */
    set fillToFit(enable) {
        this._fillToFit = enable;
        this.fillToFitChange.next(enable);
    }
    /**
     * @param {?} enable
     * @return {?}
     */
    setFillToFit(enable) {
        this.fillToFit = enable;
    }
    /**
     * @return {?}
     */
    get dragDropHoverBgEnabled() {
        return this._dragDropHoverBgEnabled;
    }
    /**
     * @param {?} enable
     * @return {?}
     */
    set dragDropHoverBgEnabled(enable) {
        this._dragDropHoverBgEnabled = enable;
        this.dragDropHoverBgEnabledChange.next(enable);
    }
    /**
     * @param {?} enable
     * @return {?}
     */
    setDragDropHoverBgEnabled(enable) {
        this.dragDropHoverBgEnabled = enable;
    }
    /**
     * @return {?}
     */
    get dragDropHoverBgColor() {
        return this._dragDropHoverBgColor;
    }
    /**
     * @param {?} style
     * @return {?}
     */
    set dragDropHoverBgColor(style) {
        this._dragDropHoverBgColor = style;
        this.dragDropHoverBgColorChange.next(style);
    }
    /**
     * @param {?} style
     * @return {?}
     */
    setDragDropHoverBgColor(style) {
        this.dragDropHoverBgColor = style;
    }
    /**
     * @return {?}
     */
    get dragDropHoverBgOpacity() {
        return this._dragDropHoverBgOpacity;
    }
    /**
     * @param {?} val
     * @return {?}
     */
    set dragDropHoverBgOpacity(val) {
        this._dragDropHoverBgOpacity = val;
        this.dragDropHoverBgOpacityChange.next(val);
    }
    /**
     * @param {?} val
     * @return {?}
     */
    setDragDropHoverBgOpacity(val) {
        this.dragDropHoverBgOpacity = val;
    }
    /**
     * @return {?}
     */
    get baseMaxWidth() {
        return this.maxheight / this.aspectRatio;
    }
    /**
     * @return {?}
     */
    get maxWidth() {
        return this.count === 2 ? 'none' : this.baseMaxWidth + 'px';
    }
    /**
     * @return {?}
     */
    get aspectRatioPct() {
        return this.aspectRatio * 100;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        /** @type {?} */
        const takeByPlatform = (/**
         * @template T
         * @param {?} source
         * @return {?}
         */
        (source) => isPlatformServer(this._platformId)
            ? source.pipe(take(1))
            : source.pipe(takeUntil(this.onDestroy)));
        this.fadeStream.pipe(takeByPlatform).subscribe(this.toggleCursor);
        this.cdRefChange.pipe(takeByPlatform).subscribe(this.update);
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        // initial setup of selected ID
        this.setSelectedIdViaIndex(this.selectedIndex);
        if (isPlatformServer(this._platformId)) {
            return;
        }
        merge(this.selectedIndexChange, this.itemsChange.pipe(map((/**
         * @return {?}
         */
        () => this.selectedIndex)))).pipe(startWith(this.selectedIndex), map((/**
         * @param {?} idx
         * @return {?}
         */
        idx => maybe(this.gridItemContainers.toArray()[idx]).flatMapAuto((/**
         * @param {?} a
         * @return {?}
         */
        a => a.nativeElement)))), map((/**
         * @param {?} e
         * @return {?}
         */
        e => e
            .flatMapAuto((/**
         * @param {?} elm
         * @return {?}
         */
        elm => Array.from(elm.children)
            .find((/**
         * @param {?} a
         * @return {?}
         */
        a => a.classList.contains('list-item-some') || a.classList.contains('list-item-none')))))
            .flatMapAuto((/**
         * @param {?} a
         * @return {?}
         */
        a => {
            return {
                id: e.flatMapAuto((/**
                 * @param {?} b
                 * @return {?}
                 */
                b => b.id)).filter((/**
                 * @param {?} b
                 * @return {?}
                 */
                b => b !== '')).valueOrUndefined(),
                elm: a.children.item(0)
            };
        })))), distinctUntilChanged((/**
         * @param {?} x
         * @param {?} y
         * @return {?}
         */
        (x, y) => x.flatMapAuto((/**
         * @param {?} b
         * @return {?}
         */
        b => b.id)).valueOrUndefined() === y.flatMapAuto((/**
         * @param {?} b
         * @return {?}
         */
        b => b.id)).valueOrUndefined())), takeUntil(this.onDestroy)).subscribe((/**
         * @param {?} maybeElement
         * @return {?}
         */
        maybeElement => maybeElement.map((/**
         * @param {?} a
         * @return {?}
         */
        a => a.elm)).tapSome((/**
         * @param {?} val
         * @return {?}
         */
        (val) => this.selectedElementChange.next(val)))));
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.onDestroySource.next();
        this.onDestroySource.complete();
    }
}
FloGridListViewComponent.ɵfac = function FloGridListViewComponent_Factory(t) { return new (t || FloGridListViewComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(PLATFORM_ID), ɵngcc0.ɵɵdirectiveInject(FLO_GRID_LIST_ITEMS), ɵngcc0.ɵɵdirectiveInject(FLO_GRID_LIST_COUNT), ɵngcc0.ɵɵdirectiveInject(FLO_GRID_LIST_MIN_COUNT), ɵngcc0.ɵɵdirectiveInject(FLO_GRID_LIST_MAX_COUNT), ɵngcc0.ɵɵdirectiveInject(FLO_GRID_LIST_MAX_HEIGHT), ɵngcc0.ɵɵdirectiveInject(FLO_GRID_LIST_SELECTED_INDEX), ɵngcc0.ɵɵdirectiveInject(FLO_GRID_LIST_SELECT_NEXT_EMPTY_ON_COUNT), ɵngcc0.ɵɵdirectiveInject(FLO_GRID_LIST_SELECT_NEXT_EMPTY_ON_ADD), ɵngcc0.ɵɵdirectiveInject(FLO_GRID_LIST_SELECT_FROM_LOWER_INDICES_FIRST), ɵngcc0.ɵɵdirectiveInject(FLO_GRID_LIST_OVERLAY_ENABLED), ɵngcc0.ɵɵdirectiveInject(FLO_GRID_LIST_OVERLAY_START), ɵngcc0.ɵɵdirectiveInject(FLO_GRID_LIST_OVERLAY_FADEOUT), ɵngcc0.ɵɵdirectiveInject(FLO_GRID_LIST_OVERLAY_THROTTLE), ɵngcc0.ɵɵdirectiveInject(FLO_GRID_LIST_OVERLAY_STATIC), ɵngcc0.ɵɵdirectiveInject(FLO_GRID_LIST_OVERLAY_NG_CLASS), ɵngcc0.ɵɵdirectiveInject(FLO_GRID_LIST_OVERLAY_NG_STYLE), ɵngcc0.ɵɵdirectiveInject(FLO_GRID_LIST_DRAG_DROP_ENABLED), ɵngcc0.ɵɵdirectiveInject(FLO_GRID_LIST_ASPECT_RATIO), ɵngcc0.ɵɵdirectiveInject(FLO_GRID_LIST_TRACK_BY_FN), ɵngcc0.ɵɵdirectiveInject(FLO_GRID_LIST_CONTAINER_ID_PREFIX), ɵngcc0.ɵɵdirectiveInject(FLO_GRID_LIST_FILL_TO_FIT), ɵngcc0.ɵɵdirectiveInject(FLO_GRID_LIST_DRAG_DROP_HOVER_BG_ENABLED), ɵngcc0.ɵɵdirectiveInject(FLO_GRID_LIST_DRAG_DROP_HOVER_BG_COLOR), ɵngcc0.ɵɵdirectiveInject(FLO_GRID_LIST_DRAG_DROP_HOVER_BG_OPACITY)); };
FloGridListViewComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FloGridListViewComponent, selectors: [["flo-grid-list-view"]], contentQueries: function FloGridListViewComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, FloGridListItemSomeDirective, 5, TemplateRef);
        ɵngcc0.ɵɵcontentQuery(dirIndex, FloGridListItemNoneDirective, 5, TemplateRef);
        ɵngcc0.ɵɵcontentQuery(dirIndex, FloGridListItemSomeDragDirective, 5, TemplateRef);
        ɵngcc0.ɵɵcontentQuery(dirIndex, FloGridListItemNoneDragDirective, 5, TemplateRef);
        ɵngcc0.ɵɵcontentQuery(dirIndex, FloGridListOverlayDirective, 5, TemplateRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.gridListItemSomeTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.gridListItemNoneTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.gridListItemSomeDragTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.gridListItemNoneDragTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.gridListOverlayTemplate = _t.first);
    } }, viewQuery: function FloGridListViewComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.gridItemContainers = _t);
    } }, hostBindings: function FloGridListViewComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("fullscreenchange", function FloGridListViewComponent_fullscreenchange_HostBindingHandler() { return ctx.fullscreenchange(); })("webkitfullscreenchange", function FloGridListViewComponent_webkitfullscreenchange_HostBindingHandler() { return ctx.fullscreenchange(); })("mozfullscreenchange", function FloGridListViewComponent_mozfullscreenchange_HostBindingHandler() { return ctx.fullscreenchange(); })("MSFullscreenChange", function FloGridListViewComponent_MSFullscreenChange_HostBindingHandler() { return ctx.fullscreenchange(); });
    } }, inputs: { selectedIndex: "selectedIndex", items: "items", count: "count", min: "min", max: "max", selectNextEmptyOnCount: "selectNextEmptyOnCount", selectNextEmptyOnAdd: "selectNextEmptyOnAdd", selectFromLowerIndicesFirst: "selectFromLowerIndicesFirst", maxheight: "maxheight", selectedId: "selectedId", overlayEnabled: "overlayEnabled", overlayStatic: "overlayStatic", overlayStart: "overlayStart", overlayFadeout: "overlayFadeout", overlayThrottle: "overlayThrottle", overlayNgClass: "overlayNgClass", overlayNgStyle: "overlayNgStyle", dragDropEnabled: "dragDropEnabled", aspectRatio: "aspectRatio", trackByFn: "trackByFn", containerIdPrefix: "containerIdPrefix", fillToFit: "fillToFit", dragDropHoverBgEnabled: "dragDropHoverBgEnabled", dragDropHoverBgColor: "dragDropHoverBgColor", dragDropHoverBgOpacity: "dragDropHoverBgOpacity" }, outputs: { itemsChange: "itemsChange", countChange: "countChange", minChange: "minChange", maxChange: "maxChange", maxheightChange: "maxheightChange", selectedIdChange: "selectedIdChange", selectedIndexChange: "selectedIndexChange", selectedElementChange: "selectedElementChange", overlayEnabledChange: "overlayEnabledChange", overlayStaticChange: "overlayStaticChange", overlayStartChange: "overlayStartChange", overlayFadeoutChange: "overlayFadeoutChange", overlayThrottleChange: "overlayThrottleChange", overlayNgClassChange: "overlayNgClassChange", overlayNgStyleChange: "overlayNgStyleChange", dragDropEnabledChange: "dragDropEnabledChange", dragDropHoverBgEnabledChange: "dragDropHoverBgEnabledChange", dragDropHoverBgColorChange: "dragDropHoverBgColorChange", dragDropHoverBgOpacityChange: "dragDropHoverBgOpacityChange", selectNextEmptyOnCountChange: "selectNextEmptyOnCountChange", selectNextEmptyOnAddChange: "selectNextEmptyOnAddChange", selectFromLowerIndicesFirstChange: "selectFromLowerIndicesFirstChange", aspectRatioChange: "aspectRatioChange", trackByFnChange: "trackByFnChange", containerIdPrefixChange: "containerIdPrefixChange", fillToFitChange: "fillToFitChange", cdRefChange: "cdRefChange", viewItemChange: "viewItemChange" }, decls: 8, vars: 17, consts: [[1, "fg", "list-overlay", "mg-auto", 3, "ngClass", "ngStyle"], [4, "ngTemplateOutlet"], [1, "fg", "mg-auto", "flx", "fill"], [1, "fg", "mg-auto", "flx", "fill", "list-container"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "fg", "offscreen", 3, "ngSwitch"], ["offscreenDragContainer", ""], [4, "ngSwitchCase"], [1, "fg", "list-item-container", 3, "floGridListDragDrop", "floGridListDragDropItem", "floGridListDragDropIndex", "floGridListDragDropGridRef", "floGridListDragDropDragRef", "floGridListDragDropHoverBgEnabled", "floGridListDragDropHoverBgColor", "floGridListDragDropHoverBgOpacity", "click", "floGridListDragDropDragoverChange"], ["floGridListItemContainer", ""], [3, "ngSwitch"], ["class", "fg list-item-some", 3, "fill-to-fit", 4, "ngSwitchCase"], ["class", "fg list-item-none", 3, "fill-to-fit", 4, "ngSwitchCase"], [1, "fg", "fill", "list-item-overlay"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "fg", "list-item-some"], [1, "fg", "list-item-none"]], template: function FloGridListViewComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵpipe(1, "async");
        ɵngcc0.ɵɵtemplate(2, FloGridListViewComponent_ng_container_2_Template, 1, 0, "ng-container", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵelement(4, "div");
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵtemplate(6, FloGridListViewComponent_ng_container_6_Template, 12, 25, "ng-container", 4);
        ɵngcc0.ɵɵpipe(7, "async");
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("list-overlay-hide", ɵngcc0.ɵɵpipeBind1(1, 13, ctx.hideOverlay));
        ɵngcc0.ɵɵproperty("ngClass", ctx.overlayNgClass)("ngStyle", ctx.overlayNgStyle);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.gridListOverlayTemplate);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("max-width", ctx.baseMaxWidth, "px");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("padding-top", ctx.aspectRatioPct, "%");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("max-width", ctx.maxWidth);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind1(7, 15, ctx.viewItemChange))("ngForTrackBy", ctx.trackByFn);
    } }, dependencies: function () { return [ɵngcc1.NgClass, ɵngcc1.NgForOf, ɵngcc1.NgTemplateOutlet, ɵngcc1.NgStyle, ɵngcc1.NgSwitch, ɵngcc1.NgSwitchCase, FloGridListDragDropDirective, ɵngcc1.AsyncPipe]; }, styles: ["[_nghost-%COMP%]{display:block;position:relative;overflow:hidden;background:#000}[_nghost-%COMP%]:-webkit-full-screen   .list-container[_ngcontent-%COMP%]{position:absolute}[_nghost-%COMP%]:-webkit-full-screen{position:inherit}[_nghost-%COMP%]:-ms-fullscreen{position:inherit}[_nghost-%COMP%]:fullscreen{position:inherit}[_nghost-%COMP%]:-webkit-full-screen   .fg.list-container[_ngcontent-%COMP%], [_nghost-%COMP%]:-webkit-full-screen   .fg.mg-auto[_ngcontent-%COMP%]{max-width:none!important;max-height:none!important}[_nghost-%COMP%]:-ms-fullscreen   .fg.list-container[_ngcontent-%COMP%], [_nghost-%COMP%]:-ms-fullscreen   .fg.mg-auto[_ngcontent-%COMP%]{max-width:none!important;max-height:none!important}[_nghost-%COMP%]:fullscreen   .fg.list-container[_ngcontent-%COMP%], [_nghost-%COMP%]:fullscreen   .fg.mg-auto[_ngcontent-%COMP%]{max-width:none!important;max-height:none!important}[_nghost-%COMP%]   .fg.mg-auto[_ngcontent-%COMP%]{margin:auto}[_nghost-%COMP%]   .fg.flx[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;align-content:center}[_nghost-%COMP%]   .fg.fill[_ngcontent-%COMP%]{height:100%}[_nghost-%COMP%]   .fg.list-container[_ngcontent-%COMP%]{width:100%;flex-wrap:wrap;-webkit-box-pack:center;justify-content:center;left:0;right:0;top:0;position:absolute}[_nghost-%COMP%]   .fg.list-item-container[_ngcontent-%COMP%]{position:relative;color:#fff}[_nghost-%COMP%]   .fg.list-item-container[_ngcontent-%COMP%]    >:first-child, [_nghost-%COMP%]   .fg.list-item-container[_ngcontent-%COMP%]    >video{position:absolute;top:0;left:0;height:100%;width:100%}[_nghost-%COMP%]   .fg.list-item-container[_ngcontent-%COMP%]     video{height:100%;max-width:100%}[_nghost-%COMP%]   .fg.list-overlay[_ngcontent-%COMP%]{position:absolute;opacity:1;top:0;bottom:0;left:0;right:0;z-index:4;pointer-events:none}[_nghost-%COMP%]   .fg.list-overlay[_ngcontent-%COMP%]    >*{pointer-events:all}[_nghost-%COMP%]   .fg.list-item-overlay[_ngcontent-%COMP%]{pointer-events:none;position:absolute;top:0;left:0;right:0;opacity:1;z-index:1}[_nghost-%COMP%]   .fg.list-item-overlay.selection-border[_ngcontent-%COMP%]{-webkit-box-shadow:inset 0 0 0 2px #fff;box-shadow:inset 0 0 0 2px #fff;-webkit-transition:.2s ease-in-out;transition:.2s ease-in-out}[_nghost-%COMP%]   .fg.list-item-overlay.dragging[_ngcontent-%COMP%]{-webkit-transition:none;transition:none}[_nghost-%COMP%]   .fg.list-overlay-hide[_ngcontent-%COMP%]{opacity:0}[_nghost-%COMP%]   .fg.fill-to-fit[_ngcontent-%COMP%]    >:first-child, [_nghost-%COMP%]   .fg.fill-to-fit[_ngcontent-%COMP%]    >video{-o-object-fit:cover;object-fit:cover;width:inherit}[_nghost-%COMP%]   .fg.offscreen[_ngcontent-%COMP%]{position:absolute;top:0;left:-9999px}"], changeDetection: 0 });
/** @nocollapse */
FloGridListViewComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: ChangeDetectorRef },
    { type: Renderer2 },
    { type: NgZone },
    { type: String, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [FLO_GRID_LIST_ITEMS,] }] },
    { type: Number, decorators: [{ type: Inject, args: [FLO_GRID_LIST_COUNT,] }] },
    { type: Number, decorators: [{ type: Inject, args: [FLO_GRID_LIST_MIN_COUNT,] }] },
    { type: Number, decorators: [{ type: Inject, args: [FLO_GRID_LIST_MAX_COUNT,] }] },
    { type: Number, decorators: [{ type: Inject, args: [FLO_GRID_LIST_MAX_HEIGHT,] }] },
    { type: Number, decorators: [{ type: Inject, args: [FLO_GRID_LIST_SELECTED_INDEX,] }] },
    { type: Boolean, decorators: [{ type: Inject, args: [FLO_GRID_LIST_SELECT_NEXT_EMPTY_ON_COUNT,] }] },
    { type: Boolean, decorators: [{ type: Inject, args: [FLO_GRID_LIST_SELECT_NEXT_EMPTY_ON_ADD,] }] },
    { type: Boolean, decorators: [{ type: Inject, args: [FLO_GRID_LIST_SELECT_FROM_LOWER_INDICES_FIRST,] }] },
    { type: Boolean, decorators: [{ type: Inject, args: [FLO_GRID_LIST_OVERLAY_ENABLED,] }] },
    { type: Boolean, decorators: [{ type: Inject, args: [FLO_GRID_LIST_OVERLAY_START,] }] },
    { type: Number, decorators: [{ type: Inject, args: [FLO_GRID_LIST_OVERLAY_FADEOUT,] }] },
    { type: Number, decorators: [{ type: Inject, args: [FLO_GRID_LIST_OVERLAY_THROTTLE,] }] },
    { type: Boolean, decorators: [{ type: Inject, args: [FLO_GRID_LIST_OVERLAY_STATIC,] }] },
    { type: Object, decorators: [{ type: Inject, args: [FLO_GRID_LIST_OVERLAY_NG_CLASS,] }] },
    { type: Object, decorators: [{ type: Inject, args: [FLO_GRID_LIST_OVERLAY_NG_STYLE,] }] },
    { type: Boolean, decorators: [{ type: Inject, args: [FLO_GRID_LIST_DRAG_DROP_ENABLED,] }] },
    { type: Number, decorators: [{ type: Inject, args: [FLO_GRID_LIST_ASPECT_RATIO,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [FLO_GRID_LIST_TRACK_BY_FN,] }] },
    { type: String, decorators: [{ type: Inject, args: [FLO_GRID_LIST_CONTAINER_ID_PREFIX,] }] },
    { type: Boolean, decorators: [{ type: Inject, args: [FLO_GRID_LIST_FILL_TO_FIT,] }] },
    { type: Boolean, decorators: [{ type: Inject, args: [FLO_GRID_LIST_DRAG_DROP_HOVER_BG_ENABLED,] }] },
    { type: String, decorators: [{ type: Inject, args: [FLO_GRID_LIST_DRAG_DROP_HOVER_BG_COLOR,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [FLO_GRID_LIST_DRAG_DROP_HOVER_BG_OPACITY,] }] }
];
FloGridListViewComponent.propDecorators = {
    fullscreenchange: [{ type: HostListener, args: ['fullscreenchange',] }, { type: HostListener, args: ['webkitfullscreenchange',] }, { type: HostListener, args: ['mozfullscreenchange',] }, { type: HostListener, args: ['MSFullscreenChange',] }],
    items: [{ type: Input }],
    count: [{ type: Input }],
    min: [{ type: Input }],
    max: [{ type: Input }],
    selectNextEmptyOnCount: [{ type: Input }],
    selectNextEmptyOnAdd: [{ type: Input }],
    selectFromLowerIndicesFirst: [{ type: Input }],
    maxheight: [{ type: Input }],
    selectedIndex: [{ type: Input }],
    selectedId: [{ type: Input }],
    overlayEnabled: [{ type: Input }],
    overlayStatic: [{ type: Input }],
    overlayStart: [{ type: Input }],
    overlayFadeout: [{ type: Input }],
    overlayThrottle: [{ type: Input }],
    overlayNgClass: [{ type: Input }],
    overlayNgStyle: [{ type: Input }],
    dragDropEnabled: [{ type: Input }],
    aspectRatio: [{ type: Input }],
    trackByFn: [{ type: Input }],
    containerIdPrefix: [{ type: Input }],
    fillToFit: [{ type: Input }],
    dragDropHoverBgEnabled: [{ type: Input }],
    dragDropHoverBgColor: [{ type: Input }],
    dragDropHoverBgOpacity: [{ type: Input }],
    itemsChange: [{ type: Output }],
    countChange: [{ type: Output }],
    minChange: [{ type: Output }],
    maxChange: [{ type: Output }],
    maxheightChange: [{ type: Output }],
    selectedIdChange: [{ type: Output }],
    selectedIndexChange: [{ type: Output }],
    selectedElementChange: [{ type: Output }],
    overlayEnabledChange: [{ type: Output }],
    overlayStaticChange: [{ type: Output }],
    overlayStartChange: [{ type: Output }],
    overlayFadeoutChange: [{ type: Output }],
    overlayThrottleChange: [{ type: Output }],
    overlayNgClassChange: [{ type: Output }],
    overlayNgStyleChange: [{ type: Output }],
    dragDropEnabledChange: [{ type: Output }],
    dragDropHoverBgEnabledChange: [{ type: Output }],
    dragDropHoverBgColorChange: [{ type: Output }],
    dragDropHoverBgOpacityChange: [{ type: Output }],
    selectNextEmptyOnCountChange: [{ type: Output }],
    selectNextEmptyOnAddChange: [{ type: Output }],
    selectFromLowerIndicesFirstChange: [{ type: Output }],
    aspectRatioChange: [{ type: Output }],
    trackByFnChange: [{ type: Output }],
    containerIdPrefixChange: [{ type: Output }],
    fillToFitChange: [{ type: Output }],
    cdRefChange: [{ type: Output }],
    viewItemChange: [{ type: Output }],
    gridItemContainers: [{ type: ViewChildren, args: ['floGridListItemContainer',] }],
    gridListItemSomeTemplate: [{ type: ContentChild, args: [FloGridListItemSomeDirective, { read: TemplateRef },] }],
    gridListItemNoneTemplate: [{ type: ContentChild, args: [FloGridListItemNoneDirective, { read: TemplateRef },] }],
    gridListItemSomeDragTemplate: [{ type: ContentChild, args: [FloGridListItemSomeDragDirective, { read: TemplateRef },] }],
    gridListItemNoneDragTemplate: [{ type: ContentChild, args: [FloGridListItemNoneDragDirective, { read: TemplateRef },] }],
    gridListOverlayTemplate: [{ type: ContentChild, args: [FloGridListOverlayDirective, { read: TemplateRef },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FloGridListViewComponent, [{
        type: Component,
        args: [{ selector: 'flo-grid-list-view', template: "<div class=\"fg list-overlay mg-auto\"\n  [ngClass]=\"overlayNgClass\"\n  [ngStyle]=\"overlayNgStyle\"\n  [class.list-overlay-hide]=\"hideOverlay | async\">\n  <ng-container *ngTemplateOutlet=\"gridListOverlayTemplate\"></ng-container>\n</div>\n<div class=\"fg mg-auto flx fill\" [style.max-width.px]=\"baseMaxWidth\">\n  <div [style.padding-top.%]=\"aspectRatioPct\"></div>\n  <div class=\"fg mg-auto flx fill list-container\" [style.max-width]=\"maxWidth\">\n    <ng-container *ngFor=\"let item of viewItemChange | async; index as idx; trackBy: trackByFn\">\n      <div #offscreenDragContainer [ngSwitch]=\"item.hasValue\" class=\"fg offscreen\">\n        <ng-container *ngSwitchCase=\"false\">\n          <ng-container *ngTemplateOutlet=\"gridListItemNoneDragTemplate; context: { $implicit: item }\"></ng-container>\n        </ng-container>\n        <ng-container *ngSwitchCase=\"true\">\n          <ng-container *ngTemplateOutlet=\"gridListItemSomeDragTemplate; context: { $implicit: item }\"></ng-container>\n        </ng-container>\n      </div>\n      <div #floGridListItemContainer\n        class=\"fg list-item-container\"\n        (click)=\"setSelectedIndex(idx)\"\n        (floGridListDragDropDragoverChange)=\"dragSource.next($event)\"\n        [floGridListDragDrop]=\"dragDropEnabled\"\n        [floGridListDragDropItem]=\"item.value\"\n        [floGridListDragDropIndex]=\"idx\"\n        [floGridListDragDropGridRef]=\"this\"\n        [floGridListDragDropDragRef]=\"gridListItemSomeDragTemplate || gridListItemNoneDragTemplate ? offscreenDragContainer : undefined\"\n        [floGridListDragDropHoverBgEnabled]=\"dragDropHoverBgEnabled\"\n        [floGridListDragDropHoverBgColor]=\"dragDropHoverBgColor\"\n        [floGridListDragDropHoverBgOpacity]=\"dragDropHoverBgOpacity\"\n        [style.flex-basis.%]=\"item.flexBasis\"\n        [style.padding-top.%]=\"item.padTop\"\n        [attr.id]=\"item?.containerId\">\n        <ng-container [ngSwitch]=\"item.hasValue\">\n          <div *ngSwitchCase=\"true\" class=\"fg list-item-some\" [class.fill-to-fit]=\"fillToFit\">\n            <ng-container *ngTemplateOutlet=\"gridListItemSomeTemplate; context: { $implicit: item }\"></ng-container>\n          </div>\n          <div *ngSwitchCase=\"false\" class=\"fg list-item-none\" [class.fill-to-fit]=\"fillToFit\">\n            <ng-container *ngTemplateOutlet=\"gridListItemNoneTemplate; context: { $implicit: item }\"></ng-container>\n          </div>\n        </ng-container>\n        <div class=\"fg fill list-item-overlay\" [class.selection-border]=\"item.isShowingBorder\" [class.list-overlay-hide]=\"hideOverlay | async\"></div>\n      </div>\n    </ng-container>\n  </div>\n</div>\n", changeDetection: ChangeDetectionStrategy.OnPush, styles: [":host{display:block;position:relative;overflow:hidden;background:#000}:host:-webkit-full-screen .list-container{position:absolute}:host:-webkit-full-screen{position:inherit}:host:-ms-fullscreen{position:inherit}:host:fullscreen{position:inherit}:host:-webkit-full-screen .fg.list-container,:host:-webkit-full-screen .fg.mg-auto{max-width:none!important;max-height:none!important}:host:-ms-fullscreen .fg.list-container,:host:-ms-fullscreen .fg.mg-auto{max-width:none!important;max-height:none!important}:host:fullscreen .fg.list-container,:host:fullscreen .fg.mg-auto{max-width:none!important;max-height:none!important}:host .fg.mg-auto{margin:auto}:host .fg.flx{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;align-content:center}:host .fg.fill{height:100%}:host .fg.list-container{width:100%;flex-wrap:wrap;-webkit-box-pack:center;justify-content:center;left:0;right:0;top:0;position:absolute}:host .fg.list-item-container{position:relative;color:#fff}:host .fg.list-item-container ::ng-deep>:first-child,:host .fg.list-item-container ::ng-deep>video{position:absolute;top:0;left:0;height:100%;width:100%}:host .fg.list-item-container ::ng-deep video{height:100%;max-width:100%}:host .fg.list-overlay{position:absolute;opacity:1;top:0;bottom:0;left:0;right:0;z-index:4;pointer-events:none}:host .fg.list-overlay ::ng-deep>*{pointer-events:all}:host .fg.list-item-overlay{pointer-events:none;position:absolute;top:0;left:0;right:0;opacity:1;z-index:1}:host .fg.list-item-overlay.selection-border{-webkit-box-shadow:inset 0 0 0 2px #fff;box-shadow:inset 0 0 0 2px #fff;-webkit-transition:.2s ease-in-out;transition:.2s ease-in-out}:host .fg.list-item-overlay.dragging{-webkit-transition:none;transition:none}:host .fg.list-overlay-hide{opacity:0}:host .fg.fill-to-fit ::ng-deep>:first-child,:host .fg.fill-to-fit ::ng-deep>video{-o-object-fit:cover;object-fit:cover;width:inherit}:host .fg.offscreen{position:absolute;top:0;left:-9999px}"] }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.NgZone }, { type: String, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [FLO_GRID_LIST_ITEMS]
            }] }, { type: Number, decorators: [{
                type: Inject,
                args: [FLO_GRID_LIST_COUNT]
            }] }, { type: Number, decorators: [{
                type: Inject,
                args: [FLO_GRID_LIST_MIN_COUNT]
            }] }, { type: Number, decorators: [{
                type: Inject,
                args: [FLO_GRID_LIST_MAX_COUNT]
            }] }, { type: Number, decorators: [{
                type: Inject,
                args: [FLO_GRID_LIST_MAX_HEIGHT]
            }] }, { type: Number, decorators: [{
                type: Inject,
                args: [FLO_GRID_LIST_SELECTED_INDEX]
            }] }, { type: Boolean, decorators: [{
                type: Inject,
                args: [FLO_GRID_LIST_SELECT_NEXT_EMPTY_ON_COUNT]
            }] }, { type: Boolean, decorators: [{
                type: Inject,
                args: [FLO_GRID_LIST_SELECT_NEXT_EMPTY_ON_ADD]
            }] }, { type: Boolean, decorators: [{
                type: Inject,
                args: [FLO_GRID_LIST_SELECT_FROM_LOWER_INDICES_FIRST]
            }] }, { type: Boolean, decorators: [{
                type: Inject,
                args: [FLO_GRID_LIST_OVERLAY_ENABLED]
            }] }, { type: Boolean, decorators: [{
                type: Inject,
                args: [FLO_GRID_LIST_OVERLAY_START]
            }] }, { type: Number, decorators: [{
                type: Inject,
                args: [FLO_GRID_LIST_OVERLAY_FADEOUT]
            }] }, { type: Number, decorators: [{
                type: Inject,
                args: [FLO_GRID_LIST_OVERLAY_THROTTLE]
            }] }, { type: Boolean, decorators: [{
                type: Inject,
                args: [FLO_GRID_LIST_OVERLAY_STATIC]
            }] }, { type: Object, decorators: [{
                type: Inject,
                args: [FLO_GRID_LIST_OVERLAY_NG_CLASS]
            }] }, { type: Object, decorators: [{
                type: Inject,
                args: [FLO_GRID_LIST_OVERLAY_NG_STYLE]
            }] }, { type: Boolean, decorators: [{
                type: Inject,
                args: [FLO_GRID_LIST_DRAG_DROP_ENABLED]
            }] }, { type: Number, decorators: [{
                type: Inject,
                args: [FLO_GRID_LIST_ASPECT_RATIO]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [FLO_GRID_LIST_TRACK_BY_FN]
            }] }, { type: String, decorators: [{
                type: Inject,
                args: [FLO_GRID_LIST_CONTAINER_ID_PREFIX]
            }] }, { type: Boolean, decorators: [{
                type: Inject,
                args: [FLO_GRID_LIST_FILL_TO_FIT]
            }] }, { type: Boolean, decorators: [{
                type: Inject,
                args: [FLO_GRID_LIST_DRAG_DROP_HOVER_BG_ENABLED]
            }] }, { type: String, decorators: [{
                type: Inject,
                args: [FLO_GRID_LIST_DRAG_DROP_HOVER_BG_COLOR]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [FLO_GRID_LIST_DRAG_DROP_HOVER_BG_OPACITY]
            }] }]; }, { selectedIndex: [{
            type: Input
        }], itemsChange: [{
            type: Output
        }], countChange: [{
            type: Output
        }], minChange: [{
            type: Output
        }], maxChange: [{
            type: Output
        }], maxheightChange: [{
            type: Output
        }], selectedIdChange: [{
            type: Output
        }], selectedIndexChange: [{
            type: Output
        }], selectedElementChange: [{
            type: Output
        }], overlayEnabledChange: [{
            type: Output
        }], overlayStaticChange: [{
            type: Output
        }], overlayStartChange: [{
            type: Output
        }], overlayFadeoutChange: [{
            type: Output
        }], overlayThrottleChange: [{
            type: Output
        }], overlayNgClassChange: [{
            type: Output
        }], overlayNgStyleChange: [{
            type: Output
        }], dragDropEnabledChange: [{
            type: Output
        }], dragDropHoverBgEnabledChange: [{
            type: Output
        }], dragDropHoverBgColorChange: [{
            type: Output
        }], dragDropHoverBgOpacityChange: [{
            type: Output
        }], selectNextEmptyOnCountChange: [{
            type: Output
        }], selectNextEmptyOnAddChange: [{
            type: Output
        }], selectFromLowerIndicesFirstChange: [{
            type: Output
        }], aspectRatioChange: [{
            type: Output
        }], trackByFnChange: [{
            type: Output
        }], containerIdPrefixChange: [{
            type: Output
        }], fillToFitChange: [{
            type: Output
        }], cdRefChange: [{
            type: Output
        }], viewItemChange: [{
            type: Output
        }], items: [{
            type: Input
        }], 
    /**
     * @return {?}
     */
    fullscreenchange: [{
            type: HostListener,
            args: ['fullscreenchange']
        }, {
            type: HostListener,
            args: ['webkitfullscreenchange']
        }, {
            type: HostListener,
            args: ['mozfullscreenchange']
        }, {
            type: HostListener,
            args: ['MSFullscreenChange']
        }], count: [{
            type: Input
        }], min: [{
            type: Input
        }], max: [{
            type: Input
        }], selectNextEmptyOnCount: [{
            type: Input
        }], selectNextEmptyOnAdd: [{
            type: Input
        }], selectFromLowerIndicesFirst: [{
            type: Input
        }], maxheight: [{
            type: Input
        }], selectedId: [{
            type: Input
        }], overlayEnabled: [{
            type: Input
        }], overlayStatic: [{
            type: Input
        }], overlayStart: [{
            type: Input
        }], overlayFadeout: [{
            type: Input
        }], overlayThrottle: [{
            type: Input
        }], overlayNgClass: [{
            type: Input
        }], overlayNgStyle: [{
            type: Input
        }], dragDropEnabled: [{
            type: Input
        }], aspectRatio: [{
            type: Input
        }], trackByFn: [{
            type: Input
        }], containerIdPrefix: [{
            type: Input
        }], fillToFit: [{
            type: Input
        }], dragDropHoverBgEnabled: [{
            type: Input
        }], dragDropHoverBgColor: [{
            type: Input
        }], dragDropHoverBgOpacity: [{
            type: Input
        }], gridItemContainers: [{
            type: ViewChildren,
            args: ['floGridListItemContainer']
        }], gridListItemSomeTemplate: [{
            type: ContentChild,
            args: [FloGridListItemSomeDirective, { read: TemplateRef }]
        }], gridListItemNoneTemplate: [{
            type: ContentChild,
            args: [FloGridListItemNoneDirective, { read: TemplateRef }]
        }], gridListItemSomeDragTemplate: [{
            type: ContentChild,
            args: [FloGridListItemSomeDragDirective, { read: TemplateRef }]
        }], gridListItemNoneDragTemplate: [{
            type: ContentChild,
            args: [FloGridListItemNoneDragDirective, { read: TemplateRef }]
        }], gridListOverlayTemplate: [{
            type: ContentChild,
            args: [FloGridListOverlayDirective, { read: TemplateRef }]
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const noop = (/**
 * @return {?}
 */
() => { });
class FloGridListItemDirective {
}
FloGridListItemDirective.ɵfac = function FloGridListItemDirective_Factory(t) { return new (t || FloGridListItemDirective)(); };
FloGridListItemDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: FloGridListItemDirective, selectors: [["", "floGridListItem", ""]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FloGridListItemDirective, [{
        type: Directive,
        args: [{
                selector: '[floGridListItem]'
            }]
    }], null, null); })();
/**
 * @template TItem
 */
class FloGridListComponent {
    /**
     * @param {?} _cdRef
     * @param {?} guid
     * @param {?} _autoFillOnLoad
     */
    constructor(_cdRef, guid, _autoFillOnLoad) {
        this._cdRef = _cdRef;
        this.guid = guid;
        this._autoFillOnLoad = _autoFillOnLoad;
        this._items = [];
        this._initialFill = {};
        this._itemsNgClass = {};
        this._itemsNgStyle = {};
        this.generateItemRoles = (/**
         * @param {?} grid
         * @param {?} item
         * @return {?}
         */
        (grid, item) => {
            return {
                isSelected: grid.isIdSelected(item.id),
                isInAnother: grid.isItemInAnotherIndex(item, grid.selectedIndex),
                canAdd: grid.canAddItem(item),
                canRemoveSelf: grid.canRemoveItemSelected(item),
                canRemove: grid.canRemoveItem(item),
                canReplace: grid.canReplaceItem(item),
                canSwap: grid.canSwapItem(item),
                canSelect: grid.canSelectItem(item)
            };
        });
        this.generateDefaultItem = (/**
         * @param {?} item
         * @return {?}
         */
        (item) => {
            return {
                item,
                roles: {
                    isSelected: false,
                    isInAnother: false,
                    canAdd: false,
                    canRemoveSelf: false,
                    canRemove: false,
                    canReplace: false,
                    canSwap: false,
                    canSelect: false
                },
                actions: {
                    select: noop,
                    add: noop,
                    replace: noop,
                    remove: noop,
                    removeSelf: noop,
                    swap: noop
                }
            };
        });
        this.itemsChange = new Subject();
        this.itemsNgClassChange = new Subject();
        this.itemsNgStyleChange = new Subject();
        this.maybeGridRef = (/**
         * @return {?}
         */
        () => maybe(this.gridRef));
        this.trackByFn = (/**
         * @param {?} _idx
         * @param {?} item
         * @return {?}
         */
        (_idx, item) => item.id);
        this.onDestroy = new Subject();
        this.autoFill = (/**
         * @return {?}
         */
        () => this.maybeGridRef().tapSome((/**
         * @param {?} grid
         * @return {?}
         */
        grid => this.items
            .filter(grid.isItemNotInGrid)
            .forEach(grid.fillNextEmpty))));
    }
    /**
     * @return {?}
     */
    get items() {
        return this._items;
    }
    /**
     * @param {?} val
     * @return {?}
     */
    set items(val) {
        this._items = val.map((/**
         * @param {?} v
         * @return {?}
         */
        v => {
            return Object.assign({}, v, { id: v.id || this.guid() });
        }));
    }
    /**
     * @return {?}
     */
    get autoFillOnLoad() {
        return this._autoFillOnLoad;
    }
    /**
     * @param {?} autofill
     * @return {?}
     */
    set autoFillOnLoad(autofill) {
        this._autoFillOnLoad = autofill;
    }
    /**
     * @return {?}
     */
    get initialFill() {
        return this._initialFill;
    }
    /**
     * @param {?} initialFill
     * @return {?}
     */
    set initialFill(initialFill) {
        this._initialFill = initialFill || {};
    }
    /**
     * @return {?}
     */
    get itemsNgClass() {
        return this._itemsNgClass;
    }
    /**
     * @param {?} ngClass
     * @return {?}
     */
    set itemsNgClass(ngClass) {
        this._itemsNgClass = ngClass;
        this.itemsNgClassChange.next(ngClass);
    }
    /**
     * @return {?}
     */
    get itemsNgStyle() {
        return this._itemsNgStyle;
    }
    /**
     * @param {?} ngstyle
     * @return {?}
     */
    set itemsNgStyle(ngstyle) {
        this._itemsNgStyle = ngstyle;
        this.itemsNgStyleChange.next(ngstyle);
    }
    /**
     * @return {?}
     */
    get viewItems() {
        return this.items.map((/**
         * @param {?} item
         * @return {?}
         */
        item => {
            return this.maybeGridRef()
                .map((/**
             * @param {?} grid
             * @return {?}
             */
            grid => {
                /** @type {?} */
                const roles = this.generateItemRoles(grid, item);
                /** @type {?} */
                const itemIndexInGrid = grid.getItemIndex(item);
                return {
                    item,
                    roles,
                    actions: {
                        select: (/**
                         * @return {?}
                         */
                        () => { roles.canSelect && grid.setSelectedIndex(itemIndexInGrid); }),
                        add: (/**
                         * @return {?}
                         */
                        () => { roles.canAdd && grid.setItem(item); }),
                        replace: (/**
                         * @return {?}
                         */
                        () => { roles.canReplace && grid.replaceItem(item); }),
                        remove: (/**
                         * @return {?}
                         */
                        () => { roles.canRemove && grid.removeItem(item); }),
                        removeSelf: (/**
                         * @return {?}
                         */
                        () => { roles.canRemoveSelf && grid.removeItem(item); }),
                        swap: (/**
                         * @return {?}
                         */
                        () => { roles.canSwap && grid.swapItems(item); })
                    }
                };
            }))
                .valueOr(this.generateDefaultItem(item));
        }));
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.maybeGridRef().tapSome((/**
         * @param {?} grid
         * @return {?}
         */
        grid => {
            grid.cdRefChange
                .pipe(takeUntil(this.onDestroy))
                .subscribe((/**
             * @return {?}
             */
            () => this._cdRef.detectChanges()));
            if (this.autoFillOnLoad && Object.keys(this.initialFill).length === 0) {
                this.autoFill();
            }
        }));
    }
    /**
     * @return {?}
     */
    checkAndUpdateInitialFill() {
        this.maybeGridRef().tapSome((/**
         * @param {?} grid
         * @return {?}
         */
        grid => {
            /** @type {?} */
            const keys = Object.keys(this.initialFill);
            if (keys.length) {
                /** @type {?} */
                const _items = [];
                keys.forEach((/**
                 * @param {?} key
                 * @return {?}
                 */
                key => {
                    _items[key] = this.items.find((/**
                     * @param {?} a
                     * @return {?}
                     */
                    a => a.id === this.initialFill[key]));
                }));
                grid.setItems(_items);
            }
            this._cdRef.detectChanges();
        }));
    }
    /**
     * @param {?} sc
     * @return {?}
     */
    ngOnChanges(sc) {
        if (sc.initialFill) {
            this.checkAndUpdateInitialFill();
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.onDestroy.next();
        this.onDestroy.complete();
    }
}
FloGridListComponent.ɵfac = function FloGridListComponent_Factory(t) { return new (t || FloGridListComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(FLO_GRID_LIST_GUID_GEN), ɵngcc0.ɵɵdirectiveInject(FLO_GRID_LIST_AUTO_FILL_FROM_LIST_ON_LOAD)); };
FloGridListComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FloGridListComponent, selectors: [["flo-grid-list"]], contentQueries: function FloGridListComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, FloGridListItemDirective, 5, TemplateRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.itemTemplate = _t.first);
    } }, inputs: { items: "items", autoFillOnLoad: "autoFillOnLoad", initialFill: "initialFill", itemsNgClass: "itemsNgClass", itemsNgStyle: "itemsNgStyle", gridRef: "gridRef" }, outputs: { itemsChange: "itemsChange", itemsNgClassChange: "itemsNgClassChange", itemsNgStyleChange: "itemsNgStyleChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 2, consts: [[4, "ngFor", "ngForOf", "ngForTrackBy"], ["floGridListDragDrop", "", 3, "floGridListDragDropItem", "ngClass", "ngStyle"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"]], template: function FloGridListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, FloGridListComponent_ng_container_0_Template, 3, 7, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.viewItems)("ngForTrackBy", ctx.trackByFn);
    } }, dependencies: function () { return [ɵngcc1.NgClass, ɵngcc1.NgForOf, ɵngcc1.NgTemplateOutlet, ɵngcc1.NgStyle, FloGridListDragDropDirective]; }, changeDetection: 0 });
/** @nocollapse */
FloGridListComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: undefined, decorators: [{ type: Inject, args: [FLO_GRID_LIST_GUID_GEN,] }] },
    { type: Boolean, decorators: [{ type: Inject, args: [FLO_GRID_LIST_AUTO_FILL_FROM_LIST_ON_LOAD,] }] }
];
FloGridListComponent.propDecorators = {
    items: [{ type: Input }],
    autoFillOnLoad: [{ type: Input }],
    initialFill: [{ type: Input }],
    itemsNgClass: [{ type: Input }],
    itemsNgStyle: [{ type: Input }],
    itemsChange: [{ type: Output }],
    itemsNgClassChange: [{ type: Output }],
    itemsNgStyleChange: [{ type: Output }],
    gridRef: [{ type: Input }],
    itemTemplate: [{ type: ContentChild, args: [FloGridListItemDirective, { read: TemplateRef },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FloGridListComponent, [{
        type: Component,
        args: [{ selector: 'flo-grid-list', template: "<ng-container *ngFor=\"let viewItem of viewItems; trackBy: trackByFn\">\n  <div floGridListDragDrop [floGridListDragDropItem]=\"viewItem.item\" [ngClass]=\"itemsNgClass\" [ngStyle]=\"itemsNgStyle\">\n    <ng-container *ngTemplateOutlet=\"itemTemplate; context: { $implicit: viewItem }\"></ng-container>\n  </div>\n</ng-container>", changeDetection: ChangeDetectionStrategy.OnPush }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [FLO_GRID_LIST_GUID_GEN]
            }] }, { type: Boolean, decorators: [{
                type: Inject,
                args: [FLO_GRID_LIST_AUTO_FILL_FROM_LIST_ON_LOAD]
            }] }]; }, { itemsChange: [{
            type: Output
        }], itemsNgClassChange: [{
            type: Output
        }], itemsNgStyleChange: [{
            type: Output
        }], items: [{
            type: Input
        }], autoFillOnLoad: [{
            type: Input
        }], initialFill: [{
            type: Input
        }], itemsNgClass: [{
            type: Input
        }], itemsNgStyle: [{
            type: Input
        }], gridRef: [{
            type: Input
        }], itemTemplate: [{
            type: ContentChild,
            args: [FloGridListItemDirective, { read: TemplateRef }]
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const CLASS_DRAGGING = 'dragging';
/** @type {?} */
const CLASS_CONTAINER = '.fg.list-item-container';
/** @type {?} */
const CLASS_ITEM_OVERLAY = '.list-item-overlay';
/**
 * @template TItem, TElement
 */
class FloGridListDragDropDirective {
    /**
     * @param {?} elmRef
     * @param {?} rd
     * @param {?} platformId
     * @param {?} doc
     * @param {?} guid
     * @param {?} supportsDragImage
     */
    constructor(elmRef, rd, platformId, doc, guid, supportsDragImage) {
        this.elmRef = elmRef;
        this.rd = rd;
        this.platformId = platformId;
        this.doc = doc;
        this.guid = guid;
        this.supportsDragImage = supportsDragImage;
        this._floGridListDragDrop = false;
        this._document = (/** @type {?} */ (this.doc));
        this.floGridListDragDropDragoverChange = new Subject();
        this.getTiles = (/**
         * @return {?}
         */
        () => Array.from(this._document.querySelectorAll(CLASS_CONTAINER)));
        this.removeTileDragStyling = (/**
         * @return {?}
         */
        () => this.getTiles().forEach(this.clearItemOverlayStyle));
        this.dragId = `__fs_drag_${((/** @type {?} */ (this.guid()))).slice(0, 8)}__`;
        this.maybeClonedExists = (/**
         * @return {?}
         */
        () => this.floGridListDragDropDragRef && this.supportsDragImage()
            ? maybe(this._document.getElementById(this.dragId))
            : maybe());
        this.extractDisplayInfoFromDragEvent = (/**
         * @param {?} evt
         * @return {?}
         */
        (evt) => maybe(evt.target)
            .map((/**
         * @param {?} elm
         * @return {?}
         */
        (elm) => {
            /** @type {?} */
            const clientRect = elm.getBoundingClientRect();
            return {
                offsetX: evt.clientX - clientRect.left,
                offsetY: evt.clientY - clientRect.top,
                height: `${elm.clientHeight}px`,
                width: `${elm.clientWidth}px`
            };
        })));
        this.mutateClonedOffsetPlaceholder = (/**
         * @param {?} elm
         * @return {?}
         */
        (elm) => {
            this.rd.setStyle(elm, 'position', 'absolute');
            this.rd.setStyle(elm, 'top', '-9999px');
            this.rd.setStyle(elm, 'left', '-9999px');
            this.rd.setAttribute(elm, 'id', this.dragId);
            return elm;
        });
        this.resetStyles = (/**
         * @param {?} elm
         * @return {?}
         */
        (elm) => {
            this.rd.removeStyle(elm, 'backgroundColor');
            this.rd.removeStyle(elm, 'opacity');
        });
        this.maybeItemOverlay = (/**
         * @param {?} elm
         * @return {?}
         */
        (elm) => maybe(elm.querySelector(CLASS_ITEM_OVERLAY)));
        this.clearItemOverlayStyle = (/**
         * @param {?} elm
         * @return {?}
         */
        (elm) => this.maybeItemOverlay(elm).tapSome(this.resetStyles));
        this.setItemOverlayStyle = (/**
         * @param {?} elm
         * @return {?}
         */
        (elm) => maybe(this.floGridListDragDropHoverBgColor)
            .flatMap((/**
         * @param {?} color
         * @return {?}
         */
        color => this.maybeItemOverlay(elm).map((/**
         * @param {?} element
         * @return {?}
         */
        element => ({ element, color })))))
            .filter((/**
         * @param {?} res
         * @return {?}
         */
        res => res.element.style.backgroundColor !== res.color))
            .tapSome((/**
         * @param {?} res
         * @return {?}
         */
        res => {
            if (this.floGridListDragDropHoverBgOpacity) {
                this.rd.setStyle(res.element, 'opacity', this.floGridListDragDropHoverBgOpacity.toString());
            }
            this.rd.setStyle(res.element, 'backgroundColor', res.color);
            this.rd.addClass(res.element, CLASS_DRAGGING);
        })));
    }
    /**
     * @return {?}
     */
    get floGridListDragDrop() { return this._floGridListDragDrop; }
    /**
     * @param {?} val
     * @return {?}
     */
    set floGridListDragDrop(val) {
        this._floGridListDragDrop = (val || ((/** @type {?} */ (val))) === '') ? true : false;
        if (this._floGridListDragDrop) {
            this.rd.setAttribute(this.elmRef.nativeElement, 'draggable', 'true');
        }
        else {
            this.rd.removeAttribute(this.elmRef.nativeElement, 'draggable');
        }
    }
    /**
     * @private
     * @param {?} evt
     * @return {?}
     */
    preventDefaults(evt) {
        if (evt.preventDefault) {
            evt.preventDefault();
        }
        if (evt.stopPropagation) {
            evt.stopPropagation();
        }
    }
    /**
     * @param {?} evt
     * @return {?}
     */
    dragstart(evt) {
        maybe(evt.dataTransfer)
            .tapSome((/**
         * @param {?} dt
         * @return {?}
         */
        dt => {
            dt.setData('text', JSON.stringify({ index: this.floGridListDragDropIndex, value: this.floGridListDragDropItem }));
            this.maybeClonedExists()
                .flatMap((/**
             * @param {?} cloned
             * @return {?}
             */
            cloned => this.extractDisplayInfoFromDragEvent(evt)
                .map((/**
             * @param {?} info
             * @return {?}
             */
            info => ({ info, cloned })))))
                .tapSome((/**
             * @param {?} details
             * @return {?}
             */
            details => {
                /** @type {?} */
                const cloned = details.cloned;
                /** @type {?} */
                const info = details.info;
                /** @type {?} */
                const zIndexPlus = Date.now().toString();
                this.rd.setStyle(cloned, 'height', info.height);
                this.rd.setStyle(cloned, 'width', info.width);
                this.rd.setStyle(cloned, 'z-index', zIndexPlus.substr(zIndexPlus.length - 7));
                dt.setDragImage(cloned, info.offsetX, info.offsetY);
            }));
        }));
    }
    /**
     * @param {?} evt
     * @return {?}
     */
    dragover(evt) {
        this.preventDefaults(evt);
        this.floGridListDragDropDragoverChange.next(evt);
        if (!this.floGridListDragDropHoverBgEnabled) {
            return;
        }
        this.getTiles().forEach((/**
         * @param {?} elm
         * @return {?}
         */
        elm => {
            if (elm.contains((/** @type {?} */ (evt.target)))) {
                this.setItemOverlayStyle(elm);
            }
            else {
                this.clearItemOverlayStyle(elm);
            }
        }));
    }
    /**
     * @param {?} evt
     * @return {?}
     */
    drop(evt) {
        this.preventDefaults(evt);
        // clear styles
        if (this.floGridListDragDropHoverBgEnabled) {
            this.removeTileDragStyling();
            // ingore subtle fade-out styles
            setTimeout((/**
             * @return {?}
             */
            () => {
                this.getTiles().forEach((/**
                 * @param {?} a
                 * @return {?}
                 */
                a => {
                    this.maybeItemOverlay(a).tapSome((/**
                     * @param {?} b
                     * @return {?}
                     */
                    b => this.rd.removeClass(b, CLASS_DRAGGING)));
                }));
            }), 200); // TODO: sync with fade time 200ms
        }
        maybe(evt.dataTransfer)
            .map((/**
         * @param {?} dt
         * @return {?}
         */
        dt => (/** @type {?} */ (JSON.parse(dt.getData('text'))))))
            .map((/**
         * @param {?} from
         * @return {?}
         */
        from => ({ from, to: { index: this.floGridListDragDropIndex, value: this.floGridListDragDropItem } })))
            .filter((/**
         * @param {?} replace
         * @return {?}
         */
        replace => replace.from.index !== replace.to.index))
            .flatMap((/**
         * @param {?} replace
         * @return {?}
         */
        replace => maybe(this.floGridListDragDropGridRef)
            .map((/**
         * @param {?} gridRef
         * @return {?}
         */
        gridRef => ({ gridRef, replace })))))
            .tapSome((/**
         * @param {?} res
         * @return {?}
         */
        res => {
            maybe(res.replace.from.value)
                .filter((/**
             * @param {?} fromVal
             * @return {?}
             */
            fromVal => res.gridRef.isItemInGrid(fromVal)))
                .tap({
                none: (/**
                 * @return {?}
                 */
                () => res.gridRef.swapItemsAtIndex(res.replace.to.index, res.replace.from.value, res.replace.from.index)),
                some: (/**
                 * @param {?} _
                 * @return {?}
                 */
                _ => res.gridRef.swapItems(res.replace.from.value, res.replace.to.index))
            });
        }));
    }
    /**
     * @return {?}
     */
    ngAfterContentInit() {
        if (isPlatformServer(this.platformId)) {
            return;
        }
        this.maybeClonedExists()
            .tapNone((/**
         * @return {?}
         */
        () => {
            if (this.floGridListDragDropDragRef && this.supportsDragImage()) {
                /** @type {?} */
                const elm = this.mutateClonedOffsetPlaceholder((/** @type {?} */ (this.floGridListDragDropDragRef.cloneNode(true))));
                this.rd.appendChild(this._document.body, elm);
            }
        }));
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.maybeClonedExists()
            .filter((/**
         * @param {?} a
         * @return {?}
         */
        a => a.parentNode !== null))
            .tapSome((/**
         * @param {?} a
         * @return {?}
         */
        a => ((/** @type {?} */ (a.parentNode))).removeChild(a)));
    }
}
FloGridListDragDropDirective.ɵfac = function FloGridListDragDropDirective_Factory(t) { return new (t || FloGridListDragDropDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(PLATFORM_ID), ɵngcc0.ɵɵdirectiveInject(DOCUMENT), ɵngcc0.ɵɵdirectiveInject(FLO_GRID_LIST_GUID_GEN), ɵngcc0.ɵɵdirectiveInject(FLO_GRID_LIST_DRAG_DROP_SUPPORTED_FN)); };
FloGridListDragDropDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: FloGridListDragDropDirective, selectors: [["", "floGridListDragDrop", ""]], hostBindings: function FloGridListDragDropDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("dragstart", function FloGridListDragDropDirective_dragstart_HostBindingHandler($event) { return ctx.dragstart($event); })("dragover", function FloGridListDragDropDirective_dragover_HostBindingHandler($event) { return ctx.dragover($event); })("drop", function FloGridListDragDropDirective_drop_HostBindingHandler($event) { return ctx.drop($event); });
    } }, inputs: { floGridListDragDrop: "floGridListDragDrop", floGridListDragDropItem: "floGridListDragDropItem", floGridListDragDropIndex: "floGridListDragDropIndex", floGridListDragDropGridRef: "floGridListDragDropGridRef", floGridListDragDropHoverBgEnabled: "floGridListDragDropHoverBgEnabled", floGridListDragDropHoverBgColor: "floGridListDragDropHoverBgColor", floGridListDragDropHoverBgOpacity: "floGridListDragDropHoverBgOpacity", floGridListDragDropDragRef: "floGridListDragDropDragRef" }, outputs: { floGridListDragDropDragoverChange: "floGridListDragDropDragoverChange" } });
/** @nocollapse */
FloGridListDragDropDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: String, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [FLO_GRID_LIST_GUID_GEN,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [FLO_GRID_LIST_DRAG_DROP_SUPPORTED_FN,] }] }
];
FloGridListDragDropDirective.propDecorators = {
    floGridListDragDrop: [{ type: Input }],
    floGridListDragDropItem: [{ type: Input }],
    floGridListDragDropIndex: [{ type: Input }],
    floGridListDragDropGridRef: [{ type: Input }],
    floGridListDragDropHoverBgEnabled: [{ type: Input }],
    floGridListDragDropHoverBgColor: [{ type: Input }],
    floGridListDragDropHoverBgOpacity: [{ type: Input }],
    floGridListDragDropDragRef: [{ type: Input }],
    floGridListDragDropDragoverChange: [{ type: Output }],
    dragstart: [{ type: HostListener, args: ['dragstart', ['$event'],] }],
    dragover: [{ type: HostListener, args: ['dragover', ['$event'],] }],
    drop: [{ type: HostListener, args: ['drop', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FloGridListDragDropDirective, [{
        type: Directive,
        args: [{
                selector: '[floGridListDragDrop]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: String, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [FLO_GRID_LIST_GUID_GEN]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [FLO_GRID_LIST_DRAG_DROP_SUPPORTED_FN]
            }] }]; }, { floGridListDragDropDragoverChange: [{
            type: Output
        }], floGridListDragDrop: [{
            type: Input
        }], 
    /**
     * @param {?} evt
     * @return {?}
     */
    dragstart: [{
            type: HostListener,
            args: ['dragstart', ['$event']]
        }], 
    /**
     * @param {?} evt
     * @return {?}
     */
    dragover: [{
            type: HostListener,
            args: ['dragover', ['$event']]
        }], 
    /**
     * @param {?} evt
     * @return {?}
     */
    drop: [{
            type: HostListener,
            args: ['drop', ['$event']]
        }], floGridListDragDropItem: [{
            type: Input
        }], floGridListDragDropIndex: [{
            type: Input
        }], floGridListDragDropGridRef: [{
            type: Input
        }], floGridListDragDropHoverBgEnabled: [{
            type: Input
        }], floGridListDragDropHoverBgColor: [{
            type: Input
        }], floGridListDragDropHoverBgOpacity: [{
            type: Input
        }], floGridListDragDropDragRef: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const DEFAULT_FLO_GRID_LIST_ITEMS = [];
/** @type {?} */
const DEFAULT_FLO_GRID_LIST_DEFAULT_VIEWCOUNT = 1;
/** @type {?} */
const DEFAULT_FLO_GRID_LIST_MIN_VIEWCOUNT = 1;
/** @type {?} */
const DEFAULT_FLO_GRID_LIST_MAX_VIEWCOUNT = 64;
/** @type {?} */
const DEFAULT_FLO_GRID_LIST_MAX_HEIGHT = 800;
/** @type {?} */
const DEFAULT_FLO_GRID_LIST_SELECT_NEXT_EMPTY_ON_COUNT = false;
/** @type {?} */
const DEFAULT_FLO_GRID_LIST_SELECT_NEXT_EMPTY_ON_ADD = false;
/** @type {?} */
const DEFAULT_FLO_GRID_LIST_SELECT_FROM_LOWER_INDICES_FIRST = false;
/** @type {?} */
const DEFAULT_FLO_GRID_LIST_CONTAINER_ID_PREFIX = '__fs_grid__';
/** @type {?} */
const DEFAULT_FLO_GRID_LIST_FILL_TO_FIT = true;
/** @type {?} */
const DEFAULT_FLO_GRID_LIST_OVERLAY_ENABLED = true;
/** @type {?} */
const DEFAULT_FLO_GRID_LIST_OVERLAY_START = true;
/** @type {?} */
const DEFAULT_FLO_GRID_LIST_OVERLAY_FADEOUT = 2000;
/** @type {?} */
const DEFAULT_FLO_GRID_LIST_OVERLAY_THROTTLE = 30;
/** @type {?} */
const DEFAULT_FLO_GRID_LIST_OVERLAY_STATIC = false;
/** @type {?} */
const DEFAULT_FLO_GRID_LIST_DRAG_DROP_ENABLED = true;
/** @type {?} */
const DEFAULT_FLO_GRID_LIST_DRAG_DROP_LISTS_ENABLED = true;
/** @type {?} */
const DEFAULT_FLO_GRID_LIST_DRAG_DROP_HOVER_BG_ENABLED = true;
/** @type {?} */
const DEFAULT_FLO_GRID_LIST_DRAG_DROP_HOVER_BG_COLOR = '#808080';
/** @type {?} */
const DEFAULT_FLO_GRID_LIST_DRAG_DROP_HOVER_BG_OPACITY = 0.70;
/** @type {?} */
const DEFAULT_FLO_GRID_LIST_OVERLAY_NG_CLASS = {};
/** @type {?} */
const DEFAULT_FLO_GRID_LIST_OVERLAY_NG_STYLE = {
    'color': 'white',
    'transition-property': 'all',
    'transition-duration': '.25s',
    'transition-timing-function': 'ease-in-out'
};
/** @type {?} */
const DEFAULT_FLO_GRID_LIST_AUTO_FILL_FROM_LIST_ON_LOAD = false;
/** @type {?} */
const DEFAULT_FLO_GRID_LIST_ASPECT_RATIO = .5625 // 16/9 <=> 9/16 => .5625
;
// 16/9 <=> 9/16 => .5625
/**
 * @param {?} platformId
 * @return {?}
 */
function DEFAULT_FLO_GRID_LIST_DRAG_DROP_SUPPORTED(platformId) {
    return (/**
     * @return {?}
     */
    function supportsDragImage() {
        return isPlatformServer(platformId)
            ? false
            : 'setDragImage' in ((((/** @type {?} */ (window))).DataTransfer || (((/** @type {?} */ (window))).Clipboard) || {}).prototype || {});
    });
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function defaultFloGridListGuidGenerator() {
    /** @type {?} */
    const lambda = (/**
     * @return {?}
     */
    () => 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (/**
     * @param {?} c
     * @return {?}
     */
    c => {
        // tslint:disable: no-bitwise
        /** @type {?} */
        const r = Math.random() * 16 | 0;
        /** @type {?} */
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    })));
    return lambda;
}
/**
 * @return {?}
 */
function defaultFloGridListTrackByFn() {
    /** @type {?} */
    const lambda = (/**
     * @param {?} _idx
     * @param {?} item
     * @return {?}
     */
    (_idx, item) => item && item.value && item.value.id);
    return lambda;
}
const ɵ0 = DEFAULT_FLO_GRID_LIST_ITEMS, ɵ1 = DEFAULT_FLO_GRID_LIST_MIN_VIEWCOUNT, ɵ2 = DEFAULT_FLO_GRID_LIST_MAX_VIEWCOUNT, ɵ3 = DEFAULT_FLO_GRID_LIST_DEFAULT_VIEWCOUNT, ɵ4 = DEFAULT_FLO_GRID_LIST_MAX_HEIGHT, ɵ5 = DEFAULT_FLO_GRID_LIST_SELECT_NEXT_EMPTY_ON_COUNT, ɵ6 = DEFAULT_FLO_GRID_LIST_SELECT_NEXT_EMPTY_ON_ADD, ɵ7 = DEFAULT_FLO_GRID_LIST_SELECT_FROM_LOWER_INDICES_FIRST, ɵ8 = DEFAULT_FLO_GRID_LIST_OVERLAY_ENABLED, ɵ9 = DEFAULT_FLO_GRID_LIST_OVERLAY_STATIC, ɵ10 = DEFAULT_FLO_GRID_LIST_OVERLAY_START, ɵ11 = DEFAULT_FLO_GRID_LIST_OVERLAY_FADEOUT, ɵ12 = DEFAULT_FLO_GRID_LIST_OVERLAY_THROTTLE, ɵ13 = DEFAULT_FLO_GRID_LIST_OVERLAY_NG_CLASS, ɵ14 = DEFAULT_FLO_GRID_LIST_OVERLAY_NG_STYLE, ɵ15 = DEFAULT_FLO_GRID_LIST_DRAG_DROP_ENABLED, ɵ16 = DEFAULT_FLO_GRID_LIST_DRAG_DROP_LISTS_ENABLED, ɵ17 = DEFAULT_FLO_GRID_LIST_AUTO_FILL_FROM_LIST_ON_LOAD, ɵ18 = DEFAULT_FLO_GRID_LIST_ASPECT_RATIO, ɵ19 = DEFAULT_FLO_GRID_LIST_CONTAINER_ID_PREFIX, ɵ20 = DEFAULT_FLO_GRID_LIST_FILL_TO_FIT, ɵ21 = DEFAULT_FLO_GRID_LIST_DRAG_DROP_HOVER_BG_ENABLED, ɵ22 = DEFAULT_FLO_GRID_LIST_DRAG_DROP_HOVER_BG_COLOR, ɵ23 = DEFAULT_FLO_GRID_LIST_DRAG_DROP_HOVER_BG_OPACITY, ɵ24 = DEFAULT_FLO_GRID_LIST_DRAG_DROP_SUPPORTED;
class FloGridListModule {
    /**
     * @param {?} cfg
     * @return {?}
     */
    static config(cfg) {
        return {
            ngModule: FloGridListModule,
            providers: [
                // tslint:disable: max-line-length
                { provide: FLO_GRID_LIST_ITEMS, useValue: cfg.items !== undefined ? cfg.items : DEFAULT_FLO_GRID_LIST_ITEMS },
                { provide: FLO_GRID_LIST_MIN_COUNT, useValue: cfg.min !== undefined ? cfg.min : DEFAULT_FLO_GRID_LIST_MIN_VIEWCOUNT },
                { provide: FLO_GRID_LIST_MAX_COUNT, useValue: cfg.max !== undefined ? cfg.max : DEFAULT_FLO_GRID_LIST_MAX_VIEWCOUNT },
                { provide: FLO_GRID_LIST_COUNT, useValue: cfg.count !== undefined ? cfg.count : DEFAULT_FLO_GRID_LIST_DEFAULT_VIEWCOUNT },
                { provide: FLO_GRID_LIST_MAX_HEIGHT, useValue: cfg.maxHeight !== undefined ? cfg.maxHeight : DEFAULT_FLO_GRID_LIST_MAX_HEIGHT },
                { provide: FLO_GRID_LIST_SELECTED_INDEX, useValue: cfg.selectedIndex !== undefined ? cfg.selectedIndex : 0 },
                { provide: FLO_GRID_LIST_OVERLAY_ENABLED, useValue: cfg.overlay && cfg.overlay.enabled !== undefined ? cfg.overlay.enabled : DEFAULT_FLO_GRID_LIST_OVERLAY_ENABLED },
                { provide: FLO_GRID_LIST_OVERLAY_STATIC, useValue: cfg.overlay && cfg.overlay.static !== undefined ? cfg.overlay.static : DEFAULT_FLO_GRID_LIST_OVERLAY_STATIC },
                { provide: FLO_GRID_LIST_OVERLAY_START, useValue: cfg.overlay && cfg.overlay.start !== undefined ? cfg.overlay.start : DEFAULT_FLO_GRID_LIST_OVERLAY_START },
                { provide: FLO_GRID_LIST_OVERLAY_FADEOUT, useValue: cfg.overlay && cfg.overlay.fadeout !== undefined ? cfg.overlay.fadeout : DEFAULT_FLO_GRID_LIST_OVERLAY_FADEOUT },
                { provide: FLO_GRID_LIST_OVERLAY_THROTTLE, useValue: cfg.overlay && cfg.overlay.throttle !== undefined ? cfg.overlay.throttle : DEFAULT_FLO_GRID_LIST_OVERLAY_THROTTLE },
                { provide: FLO_GRID_LIST_OVERLAY_NG_CLASS, useValue: cfg.overlay && cfg.overlay.ngClass !== undefined ? cfg.overlay.ngClass : DEFAULT_FLO_GRID_LIST_OVERLAY_NG_CLASS },
                { provide: FLO_GRID_LIST_OVERLAY_NG_STYLE, useValue: cfg.overlay && cfg.overlay.ngStyle !== undefined ? cfg.overlay.ngStyle : DEFAULT_FLO_GRID_LIST_OVERLAY_NG_STYLE },
                { provide: FLO_GRID_LIST_DRAG_DROP_ENABLED, useValue: cfg.dragDrop && cfg.dragDrop.enabled !== undefined ? cfg.dragDrop.enabled : DEFAULT_FLO_GRID_LIST_DRAG_DROP_ENABLED },
                { provide: FLO_GRID_LIST_DRAG_DROP_FROM_LISTS_ENABLED, useValue: cfg.dragDrop && cfg.dragDrop.allowFromLists !== undefined ? cfg.dragDrop.allowFromLists : DEFAULT_FLO_GRID_LIST_DRAG_DROP_LISTS_ENABLED },
                { provide: FLO_GRID_LIST_AUTO_FILL_FROM_LIST_ON_LOAD, useValue: cfg.list && cfg.list.fillInitialListValues !== undefined ? cfg.list.fillInitialListValues : DEFAULT_FLO_GRID_LIST_DRAG_DROP_LISTS_ENABLED },
                { provide: FLO_GRID_LIST_SELECT_NEXT_EMPTY_ON_COUNT, useValue: cfg.selectNextEmptyOnCount !== undefined ? cfg.selectNextEmptyOnCount : DEFAULT_FLO_GRID_LIST_SELECT_NEXT_EMPTY_ON_COUNT },
                { provide: FLO_GRID_LIST_SELECT_NEXT_EMPTY_ON_ADD, useValue: cfg.selectNextEmptyOnAdd !== undefined ? cfg.selectNextEmptyOnAdd : DEFAULT_FLO_GRID_LIST_SELECT_NEXT_EMPTY_ON_ADD },
                { provide: FLO_GRID_LIST_SELECT_FROM_LOWER_INDICES_FIRST, useValue: cfg.selectFromLowerIndicesFirst !== undefined ? cfg.selectFromLowerIndicesFirst : DEFAULT_FLO_GRID_LIST_SELECT_FROM_LOWER_INDICES_FIRST },
                { provide: FLO_GRID_LIST_CONTAINER_ID_PREFIX, useValue: cfg.containerIdPrefix !== undefined ? cfg.containerIdPrefix : DEFAULT_FLO_GRID_LIST_CONTAINER_ID_PREFIX },
                { provide: FLO_GRID_LIST_FILL_TO_FIT, useValue: cfg.fillToFit !== undefined ? cfg.fillToFit : DEFAULT_FLO_GRID_LIST_FILL_TO_FIT },
                { provide: FLO_GRID_LIST_DRAG_DROP_HOVER_BG_ENABLED, useValue: cfg.dragDrop && cfg.dragDrop.dragOverBgEnabled !== undefined ? cfg.dragDrop.dragOverBgEnabled : DEFAULT_FLO_GRID_LIST_DRAG_DROP_HOVER_BG_ENABLED },
                { provide: FLO_GRID_LIST_DRAG_DROP_HOVER_BG_COLOR, useValue: cfg.dragDrop && cfg.dragDrop.dragOverBgColor !== undefined ? cfg.dragDrop.dragOverBgColor : DEFAULT_FLO_GRID_LIST_DRAG_DROP_HOVER_BG_COLOR },
                { provide: FLO_GRID_LIST_DRAG_DROP_HOVER_BG_OPACITY, useValue: cfg.dragDrop && cfg.dragDrop.dragOverBgOpacity !== undefined ? cfg.dragDrop.dragOverBgOpacity : DEFAULT_FLO_GRID_LIST_DRAG_DROP_HOVER_BG_OPACITY }
            ]
        };
    }
}
FloGridListModule.ɵfac = function FloGridListModule_Factory(t) { return new (t || FloGridListModule)(); };
FloGridListModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: FloGridListModule });
FloGridListModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        { provide: FLO_GRID_LIST_GUID_GEN, useFactory: defaultFloGridListGuidGenerator },
        { provide: FLO_GRID_LIST_ITEMS, useValue: ɵ0 },
        { provide: FLO_GRID_LIST_MIN_COUNT, useValue: ɵ1 },
        { provide: FLO_GRID_LIST_MAX_COUNT, useValue: ɵ2 },
        { provide: FLO_GRID_LIST_COUNT, useValue: ɵ3 },
        { provide: FLO_GRID_LIST_MAX_HEIGHT, useValue: ɵ4 },
        { provide: FLO_GRID_LIST_SELECTED_INDEX, useValue: 0 },
        { provide: FLO_GRID_LIST_SELECT_NEXT_EMPTY_ON_COUNT, useValue: ɵ5 },
        { provide: FLO_GRID_LIST_SELECT_NEXT_EMPTY_ON_ADD, useValue: ɵ6 },
        { provide: FLO_GRID_LIST_SELECT_FROM_LOWER_INDICES_FIRST, useValue: ɵ7 },
        { provide: FLO_GRID_LIST_OVERLAY_ENABLED, useValue: ɵ8 },
        { provide: FLO_GRID_LIST_OVERLAY_STATIC, useValue: ɵ9 },
        { provide: FLO_GRID_LIST_OVERLAY_START, useValue: ɵ10 },
        { provide: FLO_GRID_LIST_OVERLAY_FADEOUT, useValue: ɵ11 },
        { provide: FLO_GRID_LIST_OVERLAY_THROTTLE, useValue: ɵ12 },
        { provide: FLO_GRID_LIST_OVERLAY_NG_CLASS, useValue: ɵ13 },
        { provide: FLO_GRID_LIST_OVERLAY_NG_STYLE, useValue: ɵ14 },
        { provide: FLO_GRID_LIST_DRAG_DROP_ENABLED, useValue: ɵ15 },
        { provide: FLO_GRID_LIST_DRAG_DROP_FROM_LISTS_ENABLED, useValue: ɵ16 },
        { provide: FLO_GRID_LIST_AUTO_FILL_FROM_LIST_ON_LOAD, useValue: ɵ17 },
        { provide: FLO_GRID_LIST_ASPECT_RATIO, useValue: ɵ18 },
        { provide: FLO_GRID_LIST_TRACK_BY_FN, useFactory: defaultFloGridListTrackByFn },
        { provide: FLO_GRID_LIST_CONTAINER_ID_PREFIX, useValue: ɵ19 },
        { provide: FLO_GRID_LIST_FILL_TO_FIT, useValue: ɵ20 },
        { provide: FLO_GRID_LIST_DRAG_DROP_HOVER_BG_ENABLED, useValue: ɵ21 },
        { provide: FLO_GRID_LIST_DRAG_DROP_HOVER_BG_COLOR, useValue: ɵ22 },
        { provide: FLO_GRID_LIST_DRAG_DROP_HOVER_BG_OPACITY, useValue: ɵ23 },
        { provide: FLO_GRID_LIST_DRAG_DROP_SUPPORTED_FN, useFactory: ɵ24, deps: [PLATFORM_ID] }
    ], imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FloGridListModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [
                    FloGridListViewComponent,
                    FloGridListComponent,
                    FloGridListItemDirective,
                    FloGridListOverlayDirective,
                    FloGridListItemSomeDirective,
                    FloGridListItemNoneDirective,
                    FloGridListItemSomeDragDirective,
                    FloGridListItemNoneDragDirective,
                    FloGridListDragDropDirective
                ],
                exports: [
                    FloGridListViewComponent,
                    FloGridListComponent,
                    FloGridListItemDirective,
                    FloGridListOverlayDirective,
                    FloGridListItemSomeDirective,
                    FloGridListItemNoneDirective,
                    FloGridListItemSomeDragDirective,
                    FloGridListItemNoneDragDirective,
                    FloGridListDragDropDirective
                ],
                providers: [
                    { provide: FLO_GRID_LIST_GUID_GEN, useFactory: defaultFloGridListGuidGenerator },
                    { provide: FLO_GRID_LIST_ITEMS, useValue: ɵ0 },
                    { provide: FLO_GRID_LIST_MIN_COUNT, useValue: ɵ1 },
                    { provide: FLO_GRID_LIST_MAX_COUNT, useValue: ɵ2 },
                    { provide: FLO_GRID_LIST_COUNT, useValue: ɵ3 },
                    { provide: FLO_GRID_LIST_MAX_HEIGHT, useValue: ɵ4 },
                    { provide: FLO_GRID_LIST_SELECTED_INDEX, useValue: 0 },
                    { provide: FLO_GRID_LIST_SELECT_NEXT_EMPTY_ON_COUNT, useValue: ɵ5 },
                    { provide: FLO_GRID_LIST_SELECT_NEXT_EMPTY_ON_ADD, useValue: ɵ6 },
                    { provide: FLO_GRID_LIST_SELECT_FROM_LOWER_INDICES_FIRST, useValue: ɵ7 },
                    { provide: FLO_GRID_LIST_OVERLAY_ENABLED, useValue: ɵ8 },
                    { provide: FLO_GRID_LIST_OVERLAY_STATIC, useValue: ɵ9 },
                    { provide: FLO_GRID_LIST_OVERLAY_START, useValue: ɵ10 },
                    { provide: FLO_GRID_LIST_OVERLAY_FADEOUT, useValue: ɵ11 },
                    { provide: FLO_GRID_LIST_OVERLAY_THROTTLE, useValue: ɵ12 },
                    { provide: FLO_GRID_LIST_OVERLAY_NG_CLASS, useValue: ɵ13 },
                    { provide: FLO_GRID_LIST_OVERLAY_NG_STYLE, useValue: ɵ14 },
                    { provide: FLO_GRID_LIST_DRAG_DROP_ENABLED, useValue: ɵ15 },
                    { provide: FLO_GRID_LIST_DRAG_DROP_FROM_LISTS_ENABLED, useValue: ɵ16 },
                    { provide: FLO_GRID_LIST_AUTO_FILL_FROM_LIST_ON_LOAD, useValue: ɵ17 },
                    { provide: FLO_GRID_LIST_ASPECT_RATIO, useValue: ɵ18 },
                    { provide: FLO_GRID_LIST_TRACK_BY_FN, useFactory: defaultFloGridListTrackByFn },
                    { provide: FLO_GRID_LIST_CONTAINER_ID_PREFIX, useValue: ɵ19 },
                    { provide: FLO_GRID_LIST_FILL_TO_FIT, useValue: ɵ20 },
                    { provide: FLO_GRID_LIST_DRAG_DROP_HOVER_BG_ENABLED, useValue: ɵ21 },
                    { provide: FLO_GRID_LIST_DRAG_DROP_HOVER_BG_COLOR, useValue: ɵ22 },
                    { provide: FLO_GRID_LIST_DRAG_DROP_HOVER_BG_OPACITY, useValue: ɵ23 },
                    { provide: FLO_GRID_LIST_DRAG_DROP_SUPPORTED_FN, useFactory: ɵ24, deps: [PLATFORM_ID] }
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FloGridListModule, { declarations: function () { return [FloGridListViewComponent, FloGridListComponent, FloGridListItemDirective, FloGridListOverlayDirective, FloGridListItemSomeDirective, FloGridListItemNoneDirective, FloGridListItemSomeDragDirective, FloGridListItemNoneDragDirective, FloGridListDragDropDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [FloGridListViewComponent, FloGridListComponent, FloGridListItemDirective, FloGridListOverlayDirective, FloGridListItemSomeDirective, FloGridListItemNoneDirective, FloGridListItemSomeDragDirective, FloGridListItemNoneDragDirective, FloGridListDragDropDirective]; } }); })();

export { DEFAULT_FLO_GRID_LIST_ASPECT_RATIO, DEFAULT_FLO_GRID_LIST_AUTO_FILL_FROM_LIST_ON_LOAD, DEFAULT_FLO_GRID_LIST_CONTAINER_ID_PREFIX, DEFAULT_FLO_GRID_LIST_DEFAULT_VIEWCOUNT, DEFAULT_FLO_GRID_LIST_DRAG_DROP_ENABLED, DEFAULT_FLO_GRID_LIST_DRAG_DROP_HOVER_BG_COLOR, DEFAULT_FLO_GRID_LIST_DRAG_DROP_HOVER_BG_ENABLED, DEFAULT_FLO_GRID_LIST_DRAG_DROP_HOVER_BG_OPACITY, DEFAULT_FLO_GRID_LIST_DRAG_DROP_LISTS_ENABLED, DEFAULT_FLO_GRID_LIST_DRAG_DROP_SUPPORTED, DEFAULT_FLO_GRID_LIST_FILL_TO_FIT, DEFAULT_FLO_GRID_LIST_ITEMS, DEFAULT_FLO_GRID_LIST_MAX_HEIGHT, DEFAULT_FLO_GRID_LIST_MAX_VIEWCOUNT, DEFAULT_FLO_GRID_LIST_MIN_VIEWCOUNT, DEFAULT_FLO_GRID_LIST_OVERLAY_ENABLED, DEFAULT_FLO_GRID_LIST_OVERLAY_FADEOUT, DEFAULT_FLO_GRID_LIST_OVERLAY_NG_CLASS, DEFAULT_FLO_GRID_LIST_OVERLAY_NG_STYLE, DEFAULT_FLO_GRID_LIST_OVERLAY_START, DEFAULT_FLO_GRID_LIST_OVERLAY_STATIC, DEFAULT_FLO_GRID_LIST_OVERLAY_THROTTLE, DEFAULT_FLO_GRID_LIST_SELECT_FROM_LOWER_INDICES_FIRST, DEFAULT_FLO_GRID_LIST_SELECT_NEXT_EMPTY_ON_ADD, DEFAULT_FLO_GRID_LIST_SELECT_NEXT_EMPTY_ON_COUNT, FLO_GRID_LIST_ASPECT_RATIO, FLO_GRID_LIST_AUTO_FILL_FROM_LIST_ON_LOAD, FLO_GRID_LIST_CONTAINER_ID_PREFIX, FLO_GRID_LIST_COUNT, FLO_GRID_LIST_DRAG_DROP_ENABLED, FLO_GRID_LIST_DRAG_DROP_FROM_LISTS_ENABLED, FLO_GRID_LIST_DRAG_DROP_HOVER_BG_COLOR, FLO_GRID_LIST_DRAG_DROP_HOVER_BG_ENABLED, FLO_GRID_LIST_DRAG_DROP_HOVER_BG_OPACITY, FLO_GRID_LIST_DRAG_DROP_SUPPORTED_FN, FLO_GRID_LIST_FILL_TO_FIT, FLO_GRID_LIST_GUID_GEN, FLO_GRID_LIST_ITEMS, FLO_GRID_LIST_MAX_COUNT, FLO_GRID_LIST_MAX_HEIGHT, FLO_GRID_LIST_MIN_COUNT, FLO_GRID_LIST_OVERLAY_ENABLED, FLO_GRID_LIST_OVERLAY_FADEOUT, FLO_GRID_LIST_OVERLAY_NG_CLASS, FLO_GRID_LIST_OVERLAY_NG_STYLE, FLO_GRID_LIST_OVERLAY_START, FLO_GRID_LIST_OVERLAY_STATIC, FLO_GRID_LIST_OVERLAY_THROTTLE, FLO_GRID_LIST_SELECTED_INDEX, FLO_GRID_LIST_SELECT_FROM_LOWER_INDICES_FIRST, FLO_GRID_LIST_SELECT_NEXT_EMPTY_ON_ADD, FLO_GRID_LIST_SELECT_NEXT_EMPTY_ON_COUNT, FLO_GRID_LIST_TRACK_BY_FN, FloGridListComponent, FloGridListDragDropDirective, FloGridListItemDirective, FloGridListItemNoneDirective, FloGridListItemNoneDragDirective, FloGridListItemSomeDirective, FloGridListItemSomeDragDirective, FloGridListModule, FloGridListOverlayDirective, FloGridListViewComponent, defaultFloGridListGuidGenerator, defaultFloGridListTrackByFn, noop };

